import type { PageInfoTranslations } from "../../types/pageInfo";

export const pageInfo: PageInfoTranslations = {
  buttonLabel: "Lehe teave: {page}",
  eyebrow: "Lehe teave",
  showMe: "Näita",
  showMeLabel: "Näita: {task}",
  moreHelp: "Rohkem abikeskuses",
  search: {
    label: "Otsi abi kõigilt lehtedelt",
    placeholder: "Otsi, nt „jaga faili” või „muuda rolli”",
    clear: "Tühjenda otsing",
    matchesHeading: "Vasted",
    relatedHeading: "Seotud",
    loadingRelated: "Otsin seotud tegevusi…",
    relatedUnavailable: "Seotud tegevusi ei õnnestunud laadida. Näitan ainult sõnavasteid.",
    noMatches: "Vasteid pole. Proovi teisi sõnu või kirjelda, mida soovid teha.",
    otherPage: "Lehel {page}",
    goToPage: "Mine lehele {page}",
    openBuildingFirst: "Selle lehe kasutamiseks ava esmalt hoone.",
    resultCount: "Tulemusi: {count}",
  },
  guide: {
    title: "Abi",
    subtitle: "Kuidas Franklin töötab ja mida igal lehel teha saab.",
    overviewTitle: "Kuidas Franklin on üles ehitatud",
    overview: [
      "Franklin hoiab sinu hoonete ja projektide informatsiooni ühes mugavas keskkonnas. Organisatsioonil on hooned, igal hoonel projektid ja igal projektil oma dokumendid, ülesanded, kontaktid ja muud tööriistad ning automatsioonid.",
      "Hoone sees saate vasakpoolse külgriba ülaosas navigeerida hoone- ja projektivaate vahel. Hoonevaade hõlmab kõiki projekte ja hoone andmeid ning projektivaates leiate tööriistad spetsiifilise projekti kallal töötamiseks.",
      "Franklin töötleb üleslaaditud dokumente, et aidata su dokumentatsiooniga töötamise hõlpsamaks teha: Franklin kategoriseerib ja sorteerib kõik failid, muudab tekstisisu otsitavaks ning pakub väärtusi hoone struktureeritud andmetele. Need on abivahendid, mitte garantii — Franklin võib midagi märkamata jätta või valesti mõista, seega kontrolli sulle olulist.",
      "Lehtede allosas olev „Küsi Franklinilt…” aitab sul otsida teavet kõikidest hoone dokumentidest, andmetest ja ülesannetest, viidates alati kasutatud allikatele, ning saab sinu eest muudatusi teha, küsides enne kinnitust. Vastused ei pruugi olla täielikud, seega kontrolli allikaid, enne kui neile tugined.",
      "See, mida näed, sõltub sinu rollist ja juurdepääsust projektidele, ning see juhend näitab ainult sulle avatud osi. Iga lehe pealkirja kõrval olev „i”-ikoon selgitab seda lehte.",
    ],
    areas: {
      buildings: "Hooned",
      projects: "Projektid",
      documents: "Dokumendid",
      issues: "Ülesanded",
      viewers: "Mudel ja joonised",
      account: "Sinu konto",
      organisation: "Organisatsioon",
      billing: "Arveldus",
    },
    openPage: "Ava {page}",
    showTasks: "Mida saad teha ({count})",
  },
  projectLogTitle: "Projekti dokumentide logi",
  pages: {
    buildings: {
      intro:
        "Kõik sinu organisatsiooni hooned ühes sorditavas tabelis. Laienda hoonet, et näha selle projekte koos dokumentide, avatud ülesannete ja liikmete arvuga, või ava hoone, et jõuda selle dokumentide, ülesannete ja andmeteni. Arhiveeritud hooned on eraldi jaotises „Arhiveeritud” ja neid saab taastada.",
      items: {
        open: {
          title: "Ava hoone",
          points: [
            "Klõpsa real, et hoone avada.",
            "Kui haldad organisatsiooni, jõuad hoone töölauale; muidu hoone dokumentideni.",
            "Sortimiseks klõpsa veeru pealkirjal — „Hoone nimetus”, „Aadress”, „Hoone registrikood” või „Netopindala”; uuesti klõpsates pöördub järjekord.",
            "Hoone, mille pakett ootab veel arvelduse kinnitust, on hall ja seda ei saa veel avada.",
          ],
        },
        projects: {
          title: "Mine otse projekti",
          points: [
            "Klõpsa rea alguses noolel („Näita projekte”), et näha hoone projekte.",
            "Iga projekti juures on selle staatus, vaikeprojektil silt „Vaikimisi” ning dokumentide, avatud ülesannete ja liikmete arv.",
            "Klõpsa projektil, et avada selle dokumendid projektivaates, piiratuna selle projektiga.",
            "Kui hoones pole projekte ja sul on õigus neid luua, näed linki „+ Lisa projekt”.",
          ],
        },
        search: {
          title: "Leia hoone või projekt",
          points: [
            "Kirjuta kasti „Otsi hooneid ja projekte...” — see otsib hoonete ja projektide nimedest, suur- ja väiketähti eristamata.",
            "Kui hoone leitakse mõne projekti kaudu, avaneb see ise ja sobiv projekt on esile tõstetud.",
            "Arhiveeritud hoonete loendis otsitakse ainult hoonete nimedest.",
          ],
        },
        add: {
          title: "Lisa hoone",
          points: [
            "Klõpsa „Lisa uus hoone” või, kui loend on tühi, „Loo uus hoone”.",
            "Sisesta hoone nimetus ja aadress; vali aadressisoovitus, et täita ka „Hoone registrikood”.",
            "Registrikood on valikuline, kuid sisestatuna peab see olema täpselt 9 numbrit.",
            "Organisatsiooni omanikul võidakse paluda valida ka pakett — Free, Starter, Growing või Scale — ja kinnitada „Nõustun ja lisan hoone”.",
          ],
        },
        rename: {
          title: "Nimeta hoone ümber",
          points: [
            "Vii kursor nimele ja klõpsa pliiatsil.",
            "Enter või salvestusnupp jätab uue nime alles; Esc või rist tühistab.",
          ],
        },
        archive: {
          title: "Arhiveeri või taasta hoone",
          points: [
            "Klõpsa rea lõpus prügikasti ikoonil ja kinnita nupuga „Arhiveeri”.",
            "Vali külgmenüüst „Arhiveeritud”, et näha arhiveeritud hooneid; kui neid pole, on see hall.",
            "Klõpsa arhiveeritud hoonel „Taasta” ja kinnita; enne võidakse paluda nõustuda selle hinnaga („Nõustun ja taastan hoone”).",
          ],
        },
      },
    },
    building: {
      intro:
        "Hoone töölaud: hoone põhiandmed, projektid, hoone andmete täielikkus ja dokumentide lisandumine. See näitab alati kogu hoonet — ava projekt, et minna projektivaatesse, kus kõik külgmenüü lehed järgivad seda üht projekti. Hoone nimi ja aadress on iga hoone lehe pealkirja kohal olevas reas.",
      items: {
        openProject: {
          title: "Ava projekt",
          points: [
            "Klõpsa projekti kaardil, et avada projekti töölaud; külgmenüü läheb projektivaatesse.",
            "Igal kaardil on projekti kirjeldus, staatus ning dokumentide, liikmete ja ülesannete arv.",
            "Näha on 12 viimati muudetud projekti; „Vaata kõiki (N) →” näitab ülejäänuid.",
            "Kui on nii aktiivseid kui ka mitteaktiivseid projekte, filtreeri kaarte pealkirja „Projektid” kõrval valikutega Kõik, Aktiivne või Mitteaktiivne.",
          ],
        },
        newProject: {
          title: "Loo projekt",
          points: [
            "Klõpsa pealkirja „Projektid” kõrval „Uus projekt”.",
            "Sisesta „Projekti nimi” ja soovi korral kirjeldus, seejärel klõpsa „Loo projekt”.",
            "Loo üks projekt iga arendus-, ehitus- või renoveerimisprojekti kohta ja jaota selle failid projekti sees kaustadesse.",
          ],
        },
        manageProject: {
          title: "Muuda projekti või selle staatust",
          points: [
            "Ava kaardi ⋮ menüü ja vali „Muuda”, et muuta nime ja kirjeldust, seejärel klõpsa „Uuenda projekt”.",
            "Vali samas menüüs „Märgi mitteaktiivseks” või „Märgi aktiivseks” või klõpsa kaardil värvilisel staatusetäpil.",
            "Mitteaktiivne on ainult silt — projekt ja selle failid jäävad alles.",
          ],
        },
        archiveProject: {
          title: "Kustuta või taasta projekt",
          points: [
            "Kaardi muutmisaknas klõpsa „Kustuta projekt” ja kinnita; vaikeprojekti kustutada ei saa.",
            "Midagi ei lähe kaotsi: pealkirja kõrval olev „Näita arhiveeritud (N)” näitab kustutatud projekte.",
            "Klõpsa arhiveeritud kaardil taastamisnuppu ja kinnita nupuga „Taasta”, et projekt tagasi tuua.",
          ],
        },
        details: {
          title: "Paranda hoone andmeid",
          points: [
            "Klõpsa pealkirja all väljal „Registrikood”, „Netopind” või „Korruseid”, et seda väikeses aknas muuta; Enter salvestab.",
            "Registrikood ja korruste arv on täisarvud; netopind võib olla kümnendmurd, komaga või punktiga.",
            "Vii kursor netopinnale või korruste arvule, et näha väärtuse allikat: dokument (klõpsa eelvaateks), avalik register või kes selle muutis või kinnitas.",
          ],
        },
        buildingData: {
          title: "Vaata hoone andmeid",
          points: [
            "Jaotis „Hoone andmed” näitab kinnitatud väljade osakaalu ja riba olekutega Kinnitatud, Ootel, Tühjad ja Konfliktid.",
            "Klõpsa konfliktireal, et avada see väli, või real „… välja täita”, et näha puuduvaid välju.",
            "Laiendamise ikoon („Ava hoone andmed”) avab hoone andmete lehe.",
          ],
        },
        analytics: {
          title: "Vaata dokumentide analüütikat",
          points: [
            "„Dokumentide analüütika” ilmub, kui hoones on dokumente, koos failide koguarvu ja töödeldud failide arvuga.",
            "„Dokumendid:” näitab kategooriaid, valdkondi ja staadiume sõõrikdiagrammidena; „+N veel” näitab kõiki kirjeid.",
            "„Üleslaadimise aktiivsus” vahetab 30p, 90p ja 1a vahel ning algab lühimast vahemikust, kuhu viimane üleslaadimine jääb; „Dokumendid projekti kohta” ilmub, kui projekte on vähemalt kaks.",
            "Graafiku laiendamise ikoon („Suurenda graafikut”) avab selle suuremalt.",
          ],
        },
        viewMode: {
          title: "Vaheta hoone- ja projektivaate vahel",
          points: [
            "Kasuta külgmenüü ülaosas lülitit Hoone / Projektid.",
            "Projektide valimisel palutakse valida projekt — otsi loendist või loo uus valikuga „Uus projekt”; kui hoones on ainult üks projekt, avaneb see kohe.",
            "Projektivaates vahetab projekti pealkirja kohal projekti nime kõrval olev noolenupp.",
            "Hoonevaatesse tagasi minnes näitavad kõik lehed jälle kogu hoonet.",
          ],
        },
        chat: {
          title: "Küsi Franklinilt",
          points: [
            "Klõpsa lehe allosas „Küsi Franklinilt…”, et küsida selle hoone dokumentide, andmete ja ülesannete kohta.",
            "Franklin aitab vastuseid leida ja lisab viited kasutatud dokumentidele; vastused ei pruugi olla täielikud, seega kontrolli allikaid.",
            "Või hakka lihtsalt kirjutama ükskõik kus lehel väljaspool tekstikasti või dialoogi — tekst läheb otse vestlusesse.",
          ],
        },
      },
    },
    buildingData: {
      intro:
        "Hoone struktureeritud andmed — pinnad, materjalid, tuleohutus ja muu. Franklin pakub väärtusi hoone dokumentide, EHR registri ja 3D-failide põhjal, kuid võib mõne väärtuse märkamata jätta või valesti lugeda, seega on iga väärtuse juures näha selle olek ja allikas: vaata pakutud väärtused üle, kinnita õiged ning paranda või täida ülejäänud. Ülaosas olev ring näitab kinnitatud osa ja iga muudatus jääb ajalukku.",
      items: {
        review: {
          title: "Vaata üle pakutud väärtused",
          points: [
            "Klõpsa „Vaata üle … välja” või vajuta R, et läbida otsust ootavad väärtused.",
            "Iga väärtuse juures on allikakatkend koos leheküljega, Franklini kindlus ja „Teised väärtused”, mille saad selle asemel valida.",
            "„Kinnita” jätab väärtuse alles, „Lükka tagasi” märgib selle puuduvaks; „Jäta vahele” ja „Eelmine” liiguvad edasi ilma otsustamata.",
            "Klahvid: A kinnitab, X lükkab tagasi, S või → viib järgmise juurde, ← eelmise juurde, Esc lõpetab.",
          ],
        },
        inspect: {
          title: "Vaata, kust väärtus pärineb",
          points: [
            "Klõpsa väljal, et avada loendi kõrval inspektor; selle laiust saad muuta serva lohistades.",
            "Seal on praegune väärtus, allikaviide ja välja ajalugu.",
            "Klõpsa allikadokumendil, et see avada; „Muud mainimised (N)” näitab teisi katkendeid, kus välja mainitakse.",
          ],
        },
        confirm: {
          title: "Kinnita, muuda või lükka väärtus tagasi",
          points: [
            "Real olekuga Vajab ülevaatamist klõpsa linnukesel kinnitamiseks, pliiatsil muutmiseks või ristil tagasilükkamiseks.",
            "Muutmisel salvestab Enter ja Esc tühistab; ebatavalise väärtuse puhul küsitakse „Salvesta siiski” või „Muuda”.",
            "Pärast muudatust klõpsa teates „Võta tagasi”, et eelmine väärtus taastada.",
            "Kinnitatud väljal jääb hilisemaks parandamiseks alles ainult pliiats.",
          ],
        },
        conflicts: {
          title: "Lahenda vastuolulised väärtused",
          points: [
            "Väli, mille allikad lähevad lahku, näitab ühe väärtuse asemel „… valikut”.",
            "Klõpsa selle pliiatsil, et näha võimalikke väärtusi, ja klõpsa ühel kinnitamiseks või sisesta oma väärtus ja salvesta see.",
            "Kui uus leid erineb kinnitatud väärtusest, vali „Säilita praegune väärtus” või „Aktsepteeri uus väärtus”.",
          ],
        },
        confirmSection: {
          title: "Kinnita terve jaotis",
          points: [
            "Iga jaotise päis näitab, mitu selle välja on kinnitatud; klõpsa päisel, et jaotis ahendada või laiendada.",
            "Klõpsa päises „Kinnita kõik N”, et kinnitada jaotise ülevaatust ootavad väärtused.",
            "Vastuoluliste väärtustega välju ei kinnitata ja ebatavalised väärtused jäävad sulle ükshaaval ülevaatamiseks.",
          ],
        },
        fillMissing: {
          title: "Täida puuduv väärtus",
          points: [
            "Vali vahekaart Puudub, et näha tühje välju.",
            "Klõpsa real „Lisa väärtus” ja sisesta see; kindlate valikutega väljadel saad väärtuse valida loendist.",
          ],
        },
        filter: {
          title: "Filtreeri oleku järgi",
          points: [
            "Vali Kõik, Kinnitatud, Vajab ülevaatamist või Puudub; iga vahekaardi juures on selle arv.",
            "Vii kursor ülaosas olevale ringile, et näha protsendi taga olevaid arve.",
          ],
        },
        search: {
          title: "Otsi välju",
          points: [
            "Kirjuta kasti „Otsi välju…” või vajuta /, et sinna liikuda.",
            "Laial ekraanil viib vasakpoolne loend „Jaotised” otse jaotiseni; selle nupp ahendab loendi.",
          ],
        },
        history: {
          title: "Vaata muudatusi",
          points: [
            "Ajaloo ikoon avab „Hoone andmete ajalugu”, kus on kõik hoone andmete muudatused.",
            "Klõpsa kirjel, et näha selle välja väärtuse ajalugu; ühe välja ajalugu on ka selle inspektoris.",
          ],
        },
      },
    },
    editBuilding: {
      intro:
        "Muuda põhiandmeid, millega hoonet Franklinis tuvastatakse: nimetus, aadress, ehitusaasta ja netopindala. Salvestamise järel naased hoone töölauale. Registrikoodi, korruste arvu ja muid andmeid muudetakse hoone töölaual ja hoone andmete lehel.",
      items: {
        fields: {
          title: "Muuda andmeid",
          points: [
            "Muuda välju „Hoone nimetus”, „Aadress”, „Ehitusaasta” ja „Netopindala”.",
            "Nimetuses peab olema vähemalt 2 ja aadressis vähemalt 5 tähemärki.",
            "Ehitusaasta on kohustuslik: neljakohaline aasta, mis ei ole hilisem kui tänavune. Netopindala on valikuline.",
          ],
        },
        address: {
          title: "Vali aadress",
          points: [
            "Kirjuta aadressi väljale vähemalt 3 tähemärki, et saada soovitusi Eesti aadressiandmete süsteemist; klõpsa ühel, et see sisestada.",
            "Aadress salvestatakse ainult siis, kui seda muudad.",
          ],
        },
        save: {
          title: "Salvesta",
          points: [
            "Klõpsa „Salvesta”, et muudatused alles jätta ja hoone töölauale naasta.",
            "Probleemiga välja all on teade; enne selle parandamist midagi ei salvestata.",
          ],
        },
      },
    },
    projectDashboard: {
      intro:
        "Valitud projekti ülevaade: sõnumitahvel, viimased muudatused, sinu tähtajaga ülesanded, lähteülesanne ja projekti dokumentide analüütika. See näitab alati ühte projekti — vaheta projekti pealkirja kohal projekti nime kõrval oleva noolenupuga. Iga jaotis viib edasi täislehele: Ülesanded, Minu ülesanded, Dokumendid või Lähteülesanne.",
      items: {
        messages: {
          title: "Postita sõnumitahvlile",
          points: [
            "Kirjuta kasti „Kirjuta sõnum…”, et jõuda kõigini selles projektis; Enter saadab, Shift+Enter alustab uut rida.",
            "Kirjuta @ või klõpsa „Maini kedagi”, et inimest teavitada; silt „… uut” näitab lugemata mainimiste arvu.",
            "Lisa fail kirjaklambriga: „Lisa Franklini logist” või „Lae üles”.",
            "Klõpsa laiendamise ikoonil („Laienda”), et tahvlit suuremalt lugeda.",
          ],
        },
        replyReact: {
          title: "Vasta, reageeri, muuda või kustuta",
          points: [
            "Vii kursor sõnumile ja klõpsa „Vasta” — vastus tsiteerib seda; tsitaadil klõpsates liigud algse sõnumi juurde.",
            "Lisa reaktsioon: 👍 ✅ ❤️ 😄 🎉.",
            "„Muuda” ja „Kustuta” on ainult sinu enda sõnumitel; kustutatud sõnum eemaldatakse kõigi jaoks.",
          ],
        },
        whatsNew: {
          title: "Vaata, mis on uut",
          points: [
            "Vali jaotises „Mis on uut” ajavahemik: 24 h, 72 h, 7 päeva või 30 päeva; valik jäetakse meelde.",
            "Paanid loendavad uusi, lõpetatud ja muudetud ülesandeid, kommentaare, uusi dokumente ja uusi versioone; klõpsa näitel, et see avada.",
            "„Sulle” näitab, kus sind mainiti või sulle ülesanne määrati, ja mis on uut sinu vastutusalades.",
            "Ülesannete arvud eeldavad ligipääsu ülesannetele; dokumentide muudatusi ei näidata, kui sa ei näe kõiki projekti dokumente.",
          ],
        },
        myTasks: {
          title: "Sinu ülesanded",
          points: [
            "„Minu ülesanded” näitab sulle määratud avatud ülesandeid, mille tähtaeg jääb valitud vahemikku („Tähtaeg”): 1 nädal, 2 nädalat või 1 kuu.",
            "Tähtaja ületanud ülesanded on eespool punase kuupäevaga; järgmise 3 päeva jooksul tähtajaga ülesanded on sinise kuupäevaga.",
            "Ikoonid näitavad seotud dokumente ja kommentaare; klõpsa ülesandel, et see avada lehel Minu ülesanded, või klõpsa „Vaata kõiki minu ülesandeid”.",
          ],
        },
        brief: {
          title: "Projekti lähteülesanne",
          points: [
            "„Franklini ettepanekud” lähteülesande kohta on tõsiseimast alates; klõpsa ühel, et see lähteülesande lehel avada.",
            "Kui ettepanekuid pole, klõpsa „Ava lähteülesanne”; kui projektil pole lähteülesannet ja sul on õigus see alustada, näed nuppu „Alusta lähteülesannet”.",
          ],
        },
        analytics: {
          title: "Dokumentide tegevus",
          points: [
            "Graafikud selle projekti dokumentidest kategooriate, valdkondade ja staadiumide kaupa ning „Üleslaadimise aktiivsus” 30p, 90p või 1a kohta.",
            "„Täna üles laaditud” näitab tänaseid üleslaadimisi, uusimad eespool; klõpsa ühel eelvaateks või klõpsa „Vaata kõiki”.",
            "Jaotist pole, kui projektis dokumente pole; kui sa ei näe kõiki projekti dokumente, on näha ainult pealkiri koos põhjusega.",
          ],
        },
        switchProject: {
          title: "Vaheta projekti",
          points: [
            "Klõpsa lehe pealkirja kohal projekti nime kõrval oleval noolenupul („Vaheta projekti”).",
            "Otsi loendist ja vali projekt; töölaud ja kõik külgmenüü lehed järgivad seda.",
            "Loendi lõpus olev „Uus projekt” loob projekti ja lülitub sellele, kui sul on õigus projekte luua.",
          ],
        },
      },
    },
    documents: {
      intro:
        "Kõik selle hoone või projekti dokumendid ühes kohas. Franklin loeb iga üleslaaditud faili ning annab sellele liigi ja sildid, mida saad parandada; see aitab dokumente leida nii sisu kui ka nime järgi. Sirvi neid ajajoone, nimekirja või kaustadena ning jaga, võrdle, versioneeri, kommenteeri või kinnita neid. Filtrid, otsing ja ajalugu on vahekaartide kohal ega muutu, kui vaadet vahetad.",
      items: {
        upload: {
          title: "Lae failid üles",
          points: [
            "Klõpsa „Lae üles” või lohista failid ükskõik kuhu lehel.",
            "Vali „Lae failid üles” või „Lae kaust üles” — kaust jääb koos alamkaustadega.",
            "Kontrolli sihtkohta jaotises „Vali üleslaadimise asukoht” või klõpsa „Muuda”.",
            "Kui samas kaustas on juba sama nimega fail, vali iga faili jaoks „Uus versioon”, „Hoia mõlemat” või „Jäta vahele”.",
          ],
        },
        views: {
          title: "Vaheta vaadet",
          points: [
            "„Kaustad” näitab projekti kaustapuud; see on olemas ainult projektivaates.",
            "„Ajajoon” paigutab dokumendid kuupäeva järgi: vali „Kuupäev” väärtuseks „Üleslaadimine” või „Loomine” (failis endas olev kuupäev) ja suumi „Aastad”, „Kuud”, „Nädalad” ja „Päevad” vahel.",
            "„Nimekiri” on tabel; sortimiseks klõpsa „Nimi” või „Faili muutmisaeg”.",
            "Valitud vahekaart jäetakse meelde.",
          ],
        },
        search: {
          title: "Otsi dokumente",
          points: [
            "Kirjuta otsingukasti ja vajuta Enter — või peatu hetkeks ja otsing käivitub ise.",
            "Otsing leiab sõnu nii dokumentide sisust kui ka nimedest; sisu vasteid tähistab silt „Sisu” ja kursorit sellele viies näed lehekülge.",
            "Vaates „Kaustad” otsib see avatud kaustast ja selle alamkaustadest („Otsi kaustast...”).",
          ],
        },
        filters: {
          title: "Filtreeri sildi või projekti järgi",
          points: [
            "Klõpsa „Filtrid” ja märgi väärtused jaotistes „Projektid”, „Kategooriad”, „Valdkonnad” või „Projekti staadiumid”.",
            "Kirjuta väljale „Otsi silte…”, et leida silt ilma rühmi avamata.",
            "Lülita sisse „Ainult kinnitatud”, et näha ainult „Kinnitatud” märkega dokumente.",
            "Filtrid kehtivad kõigil vahekaartidel; „Tühjenda kõik” eemaldab need. Projekti sees on projekt lukus.",
          ],
        },
        selection: {
          title: "Tegevused valitud dokumentidega",
          points: [
            "Märgi dokumendid; Shift-klõps valib vahemiku, Ctrl-klõps (Macis ⌘) lisab või eemaldab ühe.",
            "Allservas olev riba pakub valikuid „Jaga”, „Laadi alla”, „Küsi Franklinilt” (lisab need vestlusesse) ja „Kustuta”, rohkem leiad alt „Veel”; „Tühjenda” tühistab valiku.",
            "Vali täpselt kaks PDF-i, et kasutada „Võrdle PDF-e”, või kaks töödeldud IFC-mudelit, et kasutada „Võrdle IFCsid”.",
            "Paremklõpsa dokumendil samade tegevuste ning „Nimeta ümber”, „Lisa uus versioon” ja „Kommentaarid” jaoks; failinimel klõpsates avaneb eelvaade.",
            "PDF-i või allkirjastatud konteineri rea menüüs laseb „Vaata allkirju” Dokobitil selle digiallkirjad üle kontrollida, ka väljaspool Franklinit allkirjastatud failidel, ning näitab, kui mõni allkiri kontrolli ei läbi või failil allkirju pole.",
          ],
        },
        newDocument: {
          title: "Loo dokument mallist",
          points: [
            "Klõpsa „Uus dokument” ja vali mall, näiteks „Kaetud tööde akt” või „Ehituspäevik”.",
            "„Vali eeltäidetud vorm” alustab juba salvestatud vormist; „Impordi” kopeerib sellest ühe välja.",
            "Vali „PDF-i keel”; märgi „Vorm allkirjastatakse digitaalselt”, et see kohe pärast salvestamist allkirjastada.",
            "Klõpsa „Salvesta”, vali projekt ja kaust ning klõpsa „Salvesta siia”; PDF nummerdatakse automaatselt.",
          ],
        },
        versions: {
          title: "Tööta versioonidega",
          points: [
            "Failinime kõrval olev versioonimärk avab varasemad versioonid; „Vaata kogu ajalugu” avab „Versiooniajaloo”.",
            "„Versiooniajaloos” vali võrdlemiseks kaks versiooni.",
            "Paremklõps → „Lisa uus versioon”, et laadida üles faile või „Vali dokumentide hulgast”; nimekirja viimasest saab praegune versioon.",
            "Olemasoleva dokumendi saad lisada valikuga „Teisalda” (kogu ajalugu tuleb kaasa) või „Kopeeri” (originaal jääb oma kohale).",
          ],
        },
        comments: {
          title: "Kommenteeri dokumenti",
          points: [
            "Paremklõpsa dokumendil → „Kommentaarid” või klõpsa rea kommentaaride arvul.",
            "Kirjuta kommentaar ja kasuta @, et kedagi mainida; PDF-i või arvutustabeli puhul seotakse see leheküljega või lehega, millel oled.",
            "Kui saad ülesandeid hallata, on „Loo ülesanne” märgitud ja kommentaarist saab ülesanne; eemalda märge, et jätta see tavaliseks kommentaariks.",
            "„Märgi lõpetatuks” sulgeb arutelu; „Ava uuesti” toob selle tagasi.",
          ],
        },
        verify: {
          title: "Märgi dokumendid kinnitatuks",
          points: [
            "Paremklõpsa dokumendil või vali mitu ja vali „Märgi kinnitatuks”; „Eemalda kinnitus” tühistab selle.",
            "Kinnitatud dokumentidel on märk „Kinnitatud”; vii kursor sellele, et näha, kes ja millal kinnitas.",
            "Klõpsa kinnitusteates „Võta tagasi”, et see kohe tagasi võtta.",
            "Uue versiooni lisamisel on see versioon jälle kinnitamata.",
          ],
        },
        organise: {
          title: "Korrasta kaustu",
          points: [
            "Vaates „Kaustad” klõpsa „Korrasta” — see korrastab avatud kausta või, kui ükski pole avatud, projekti juurkausta. Toimib ka paremklõps kaustal → „Korrasta”.",
            "„Franklin otsustab” loeb failid läbi ja pakub välja struktuuri, mille saad üle vaadata; „Siltide järgi” rühmitab need kohe liigi, eriala või etapi järgi.",
            "Võid akna sulgeda, kuni Franklin töötab; kui ettepanek on valmis, muutub nupp „Vaata ettepanek üle”.",
            "Midagi ei liigu enne, kui klõpsad „Rakenda”; uusi kaustu saab enne ümber nimetada.",
          ],
        },
        share: {
          title: "Jagamislingid",
          points: [
            "Jagamislingiga saab igaüks, kellel see on, faile vaadata ja alla laadida ilma Franklini kontota.",
            "Vali dokumendid ja klõpsa „Jaga” või paremklõpsa kaustal → „Jaga kausta”; määra „Link aegub” (1 tunnist 30 päevani) ja klõpsa „Loo link”.",
            "⋮ menüü → „Halda jagamisi” näitab kõiki linke koos vaatamiste ja olekuga ning „Tühista jagamine” lülitab lingi kohe välja.",
          ],
        },
        trash: {
          title: "Taasta kustutatud dokumendid",
          points: [
            "„Kustuta” liigutab dokumendid prügikasti; ava see ⋮ menüüst → „Prügikast”.",
            "Klõpsa „Taasta”, et dokument tagasi panna.",
            "Kustutatud dokumente hoitakse 30 päeva, seejärel eemaldatakse need jäädavalt.",
            "Kui sul on õigus faile lõplikult kustutada, on seal ka „Kustuta jäädavalt” ja „Tühjenda prügikast”.",
          ],
        },
        history: {
          title: "Vaata dokumentide ajalugu",
          points: [
            "Otsingu kõrval olev ajaloo ikoon avab „Dokumendi ajaloo”: kes millise dokumendi lisas, muutis, ümber nimetas, kustutas või taastas ja millal.",
            "Kitsenda seda valikutega „Kõik tegevused”, „Lisatud”, „Muudetud”, „Ümber nimetatud” või „Kustutatud” või otsi dokumendi või inimese järgi.",
            "Ava või laadi dokument alla selle kirjelt; kustutatud dokumendil on nupp „Taasta”.",
            "Klõpsa „Laadi vanemad”, et minna kaugemale ajas tagasi.",
          ],
        },
      },
    },
    projectFolders: {
      intro:
        "Projekti enda kaustad ja failid, mis avanevad projekti lehelt. Vasakul on kaustapuu ja paremal avatud kausta sisu. Siin saad üles laadida, kaustu luua, otsida, valida, liigutada, jagada ja korrastada. Franklin loeb lisatut ja sildistab selle, et aidata sul seda hiljem leida, ning samad failid on näha ka hoone dokumentide lehel.",
      items: {
        browse: {
          title: "Sirvi kaustu",
          points: [
            "Klõpsa kaustal puus või loendis. Selle kõrval olev number näitab dokumentide arvu.",
            "Loendi kohal olev asukohariba viib tagasi üles. Projekti nimel klõpsates jõuad algusesse.",
            "Kitsas aknas on puu peidetud, seega kasuta noolenuppu „Tagasi projekti juurkausta”.",
            ".zip-fail avaneb nagu kaust, nii et saad selle sisu sirvida.",
          ],
        },
        upload: {
          title: "Lae failid üles",
          points: [
            "Klõpsa „Lae üles”, siis „Lae failid üles” või „Lae kaust üles”. Üles laaditud kaust säilitab oma alamkaustad.",
            "Failid lähevad avatud kausta. Dialoogis „Muuda” abil saad valida selle projekti teise kausta.",
            "Võid ka lohistada failid arvutist lehele või otse puus või asukoharibal olevale kaustale.",
            "Kui samanimeline fail on juba olemas, vali „Uus versioon”, „Hoia mõlemat” või „Jäta vahele”.",
          ],
        },
        newFolder: {
          title: "Loo kaust",
          points: [
            "Klõpsa „Uus kaust”, et luua kaust avatud kausta sisse.",
            "Või paremklõpsa loendi tühjal alal → „Uus kaust”.",
            "Teise kausta sisse loomiseks ava selle kausta ⋮ menüü või paremklõpsa seda → „Loo alamkaust”.",
          ],
        },
        search: {
          title: "Otsi sellest kaustast",
          points: [
            "Kirjuta väljale „Otsi kaustast...” ja vajuta Enter või tee kirjutamises paus.",
            "Otsing hõlmab avatud kausta ja kõiki selle sees olevaid kaustu. Ülemisel tasemel on see kogu projekt.",
            "Otsitakse failinimedest ja dokumentide tekstist. Tekstivasteid märgib silt „Sisu”.",
          ],
        },
        selection: {
          title: "Tegevused valitud failidega",
          points: [
            "Märgi fail või klõpsa selle real, et see valida. Shift-klõps valib vahemiku ja Ctrl/⌘-klõps lisab veel ühe. Faili nimel klõpsates avaneb eelvaade.",
            "Kausta märkimine valib kausta ja kõik selle sisu.",
            "Tegevusribal on „Jaga”, „Laadi alla”, „Liiguta/Kopeeri”, „Nimeta ümber”, „Lisa uus versioon”, „Küsi Franklinilt” ja „Kustuta”, sobival juhul ka „Võrdle PDF-e”, „Allkiri” või „Märgi kinnitatuks”.",
            "Samad tegevused avanevad ka failil paremklõpsates.",
          ],
        },
        folderMenu: {
          title: "Kasuta kausta menüüd",
          points: [
            "Vii hiir kaustale ja klõpsa ⋮ või paremklõpsa kausta puus või loendis.",
            "„Ekspordi kaust” laadib selle alla zip-failina koos alamkaustadega. „Jaga kausta” loob sellele jagamislingi.",
            "„Loo alamkaust”, „Korrasta”, „Nimeta ümber” ja „Kustuta” on nähtavad, kui sul on nende jaoks õigus.",
            "Kausta kustutamine viib selle dokumendid prügikasti.",
          ],
        },
        move: {
          title: "Liiguta või kopeeri faile",
          points: [
            "Lohista failid või kaustad puus, loendis või asukoharibal olevale kaustale. Kaustad, kuhu saab kukutada, on esile tõstetud.",
            "Märgitud üksuse lohistamine liigutab kogu valiku.",
            "Teise projekti liigutamiseks või kopeerimiseks vali üksused ja klõpsa „Liiguta/Kopeeri”. Vali „Liiguta” või „Kopeeri”, siis projekt ja kaust.",
          ],
        },
        share: {
          title: "Jaga linki",
          points: [
            "Vali failid või kaustad ja klõpsa „Jaga” või kasuta kausta juures „Jaga kausta”.",
            "Vali, millal link aegub („1 tund”, „24 tundi”, „7 päeva” või „30 päeva”), siis klõpsa „Loo link” ja „Kopeeri link”.",
            "Kõik, kellel on link, saavad jagatud dokumente vaadata ja alla laadida ilma kontota.",
          ],
        },
        versions: {
          title: "Vaata ja lisa versioone",
          points: [
            "Klõpsa failinime kõrval oleval versioonimärgil, et näha selle all varasemaid versioone. „Vaata kogu ajalugu” avab need kõik.",
            "Paremklõpsa failil → „Lisa uus versioon”, et lisada järgmiseks versiooniks üles laaditav fail või olemasolev dokument.",
            "Vanemaid IFC- ja DWG-versioone saab märkida, et võrrelda sama faili kahte versiooni.",
          ],
        },
        organise: {
          title: "Korrasta kaustu",
          points: [
            "Klõpsa „Korrasta”, et korrastada avatud kausta või, kui ükski kaust pole avatud, projekti ülemist taset.",
            "„Franklin otsustab” pakub failide sisu põhjal struktuuri, mille saad üle vaadata. „Siltide järgi” rühmitab need kohe nende siltide järgi.",
            "Vali „Ainult lahtised failid” või „Kogu kaustapuu”. Analüüs võib võtta mõne minuti ja kui see on valmis, muutub nupp „Vaata ettepanek üle”.",
            "Midagi ei liigu enne, kui klõpsad „Rakenda”. „Loobu” tühistab ettepaneku.",
          ],
        },
        specialFolders: {
          title: "Tunne erikaustu",
          points: [
            "„Ülesande lisad” sisaldab ülesannetele lisatud faile. Neid lisatakse ülesannete lehelt, seega ei saa sinna üles laadida ega kaustu luua. Selle faile saab mujale kopeerida, kuid mitte teisaldada ega kustutada; eemalda fail enne ülesandelt.",
            "Kaust „Lähteülesanne” sisaldab projekti lähteülesannet ning seda ei saa ümber nimetada, kustutada ega korrastada. „Näita vanemaid versioone” loetleb selle kinnitatud versioonid ja iga versioon avaneb lähteülesande lehel. Additions.pdf jääb sellesse kausta: mujal kasutamiseks kopeeri see.",
            "Allkirjastatud konteiner (.asice, .bdoc) on üks fail, mitte kaust. Ava see, et näha allkirju.",
          ],
        },
        trash: {
          title: "Taasta kustutatud failid",
          points: [
            "Klõpsa ⋮ → „Prügikast”, et näha kustutatud dokumente. „Tagasi dokumentide juurde” viib kaustade juurde tagasi.",
            "Klõpsa dokumendi juures „Taasta”, et see tagasi tuua.",
            "Kustutatud dokumente hoitakse 30 päeva, siis eemaldatakse need jäädavalt.",
            "Kustutamisõigusega kasutajad saavad ka „Kustuta jäädavalt” või „Tühjenda prügikast”.",
          ],
        },
      },
    },
    projectLog: {
      intro:
        "Selle projekti dokumentide kirjutuskaitstud loend, viimati muudetud eespool. Loendis on ka prügikasti viidud dokumendid, nii et näed kõike, mis siin on toimunud. Failide avamiseks, liigutamiseks või taastamiseks kasuta projekti kaustade lehte.",
      items: {
        read: {
          title: "Loe logikirjet",
          points: [
            "Igal real on failinimi, versioon (v1, v2 …), töötlemise olek ja viimase muutmise aeg.",
            "Viimane osa (#…) on faili viimati muutnud kasutaja number.",
            "Iga versioon on eraldi rida, nii et kolme versiooniga fail on loendis kolm korda.",
          ],
        },
        live: {
          title: "Jälgi uuenemist",
          points: [
            "Logi uueneb ise, kui dokumente lisatakse, muudetakse või projektist välja viiakse.",
            "Näha on 200 viimati muudetud dokumenti.",
          ],
        },
        archived: {
          title: "Leia kustutatud dokumendid",
          points: [
            "Prügikasti viidud dokumendid jäävad logisse märgiga „archived”.",
            "Taastamiseks ava projekti kaustad ja vali ⋮ → „Prügikast”.",
          ],
        },
      },
    },
    signing: {
      intro:
        "Kõik selle projekti allkirjastatud konteinerid ja allkirjastamise ahelad, uusimad eespool. Vali rida, et näha, kes on allkirjastanud, kelle kord on ja milliseid dokumente see hõlmab, ning allkirjasta, laadi alla või kontrolli seisu loendi kõrval olevast paneelist. Lõpetatud allkirjastamised salvestatakse projekti dokumentide juurde. Uue allkirjastamise alustamiseks ava dokumendid, vali failid ja klõpsa „Allkiri”.",
      items: {
        signTurn: {
          title: "Allkirjasta, kui on sinu kord",
          points: [
            "Read olekuga „Ootab sinu allkirja” vajavad sinu allkirja; kui on sinu kord, saad e-kirja.",
            "Vali rida ja klõpsa „Allkirjasta kohe”.",
            "Vali allkirjastamisaknas Smart-ID, Mobiil-ID või ID-kaart ja allkirjasta.",
            "Pärast sinu allkirja liigub see järgmisele allkirjastajale; viimase allkirja järel salvestatakse allkirjastatud fail dokumentide juurde.",
          ],
        },
        tabs: {
          title: "Sinu omad või kõik",
          points: [
            "„Kõik allkirjad” (vaikimisi) näitab kõiki selle projekti allkirjastamisi, mida sul on lubatud näha.",
            "„Minu allkirjad” jätab alles ainult need, mille sina alustasid või mida sul paluti allkirjastada.",
          ],
        },
        details: {
          title: "Vaata allkirjastajaid ja faile",
          points: [
            "Klõpsa real (või vajuta sellel Enter), et see külgpaneelis avada; kuni sa midagi ei vali, näidatakse esimest rida.",
            "„Allkirjastajad” näitab edenemist, nt „2 / 3 allkirjastatud”, ja iga inimese olekut: „Ootel”, „Allkirjastatud”, „Keeldus” või „Eemaldatud”, ning kasutatud allkirjastamisviisi.",
            "Sammud on nummerdatud („1. samm”…); samal sammul olijad võivad allkirjastada suvalises järjekorras.",
            "„Selle seansi dokumendid” või „Konteineri sisu” loetleb kaasatud failid.",
          ],
        },
        statuses: {
          title: "Loe olekut",
          points: [
            "„Ootab sinu allkirja”: järgmisena on sinu allkiri. „Ootab teisi”: kord on kellelgi teisel.",
            "„Vormistamisel”: kõik allkirjad on olemas ja ümbrikku vormistatakse; leht kontrollib seda ise ja muudab olekuks „Allkirjastatud”.",
            "„Ebaõnnestus”, „Tühistatud” ja „Aegunud” tähendavad, et allkirjastamine lõppes konteinerita; ebaõnnestunu puhul näitab paneel teenusepakkuja põhjust.",
          ],
        },
        filter: {
          title: "Filtreeri loendit",
          points: [
            "Klõpsa „Filter” ja vali „Olek”, „Allkirjastaja” või „Kuupäev”.",
            "„Kuupäev” võtab päevad „Alates” ja „Kuni” ning vaatab, millal allkirjastamine loodi.",
            "Iga aktiivne filter on kiibina näha; klõpsa sellel muutmiseks, ×-il eemaldamiseks või „Tühjenda”, et eemaldada kõik.",
          ],
        },
        search: {
          title: "Otsi allkirjastamisi",
          points: [
            "Kirjuta väljale „Otsi dokumente…”; loend kitseneb kirjutamise ajal.",
            "Otsing vaatab dokumendi nime, saatjat ja kõigi allkirjastajate nimesid.",
          ],
        },
        sort: {
          title: "Sorteeri loendit",
          points: [
            "Sorteerimiseks klõpsa veeru „Dokument”, „Saatja” või „Loodud” pealkirjal; uuesti klõpsates pöörad järjekorra ümber.",
            "Loend algab „Loodud” järgi uusimatest.",
            "„Loodud” on aeg, mil kirje Franklinis loodi, mitte kuupäev failist endast.",
          ],
        },
        download: {
          title: "Laadi allkirjastatud konteiner alla",
          points: [
            "Vali allkirjastatud konteiner ja klõpsa paneelis „Laadi alla”.",
            "Paneel näitab ka selle allkirju ja „Konteineri sisu”.",
          ],
        },
        selection: {
          title: "Tööta mitme konteineriga",
          points: [
            "Märgi allkirjastatud konteinerid (ainult neil on märkeruut) või märgi päise ruut, et valida kõik.",
            "Allservas olev riba pakub valikuid „Jaga”, „Laadi alla” ja „Küsi Franklinilt”, mis lisab need vestlusesse.",
            "Kui sul on projektis failide muutmise õigus, on seal ka „Märgi kinnitatuks” või „Eemalda kinnitus”.",
          ],
        },
        status: {
          title: "Kontrolli või tühista ahel",
          points: [
            "„Kontrolli olekut” küsib allkirjastamisteenuselt avatud ahela seisu ja värskendab seda.",
            "Ahela saatja saab klõpsata „Tühista allkirjastamine”, kuni see on veel avatud või vormistamisel.",
            "Tühistamine küsib kinnitust: kõik ootel allkirjastajad kaotavad ligipääsu ja konteinerit ei looda; „Jäta avatuks” loobub.",
          ],
        },
        start: {
          title: "Alusta uut allkirjastamist",
          points: [
            "Allkirjastamine algab dokumentide lehel: vali ühe projekti failid ja klõpsa „Allkiri”.",
            "Vali „Allkirjastan ise”, et kohe allkirjastada, või „Saada teistele”, et kutsuda inimesi samm-sammult.",
            "„Väljundvorming” all hoiab „ASiC-E konteiner (.asice)” ühte või mitut faili koos allkirjastatud konteineris; „Allkirjastatud PDF / PAdES (.pdf)” jätab ühe PDF-i PDF-iks, mille sisse allkirjad lisatakse.",
            "Ühes allkirjastamises saab olla kuni 10 inimest, sina kaasa arvatud.",
          ],
        },
        unfiled: {
          title: "Projektita allkirjastamised",
          points: [
            "Märkega „Projektita” rida ei ole ühegi projekti alla salvestatud, seega on see näha selle hoone kõigis projektides.",
            "Laaditakse ainult 500 viimast kirjet; kui vanemad jäävad välja, ütleb seda märkus loendi kohal.",
          ],
        },
      },
    },
    brief: {
      intro:
        "Projekti lähteülesanne: projekti nõuete dokumendid lähteülesande kaustas ja kirjalikud täiendused, mis neid muudavad või täpsustavad. Nende kõrval on Franklini ettepanekud: võimalikud puudujäägid ja vastuolud, mida Franklin on märganud lähteülesande ning projekti dokumentide, ülesannete ja hoone andmete vahel, mõnel neist on ülesanne kohe loomiseks valmis. Need aitavad sul lähteülesannet üle vaadata, kuid ei asenda sinu enda ülevaatust — Franklin ei pruugi kõike märgata. Kui lähteülesanne on kokku lepitud, kinnita see nummerdatud versioonina, siis märgitakse hilisemad muudatused ja neid saab selle versiooniga võrrelda. Igal projektil on oma lähteülesanne ja selle failid on näha ka dokumentide all.",
      items: {
        start: {
          title: "Alusta lähteülesannet",
          points: [
            "Kui projektil lähteülesannet pole, klõpsa „Alusta lähteülesannet”: see loob lähteülesande ja selle kausta.",
            "Ka esimese täienduse saatmine alustab lähteülesannet.",
            "Kes lähteülesannet hallata ei saa, näeb teadet „Sellel projektil pole veel lähteülesannet.”",
          ],
        },
        addFiles: {
          title: "Lisa faile",
          points: [
            "Klõpsa „Lisa faile”, seejärel „Lae üles” uute failide jaoks või „Lisa olemasolev” projektis juba olevate dokumentide jaoks.",
            "„Lisa olemasolev” kopeerib valitud failid nupuga „Kopeeri lähteülesandesse” lähteülesandesse; originaalid jäävad oma kohale.",
            "Lähteülesande faile, mida sul pole lubatud näha, ei kuvata, vaid nende arv on nimekirja kohal.",
          ],
        },
        additions: {
          title: "Kirjuta täiendus",
          points: [
            "Kirjuta jaotises „Täiendused” muudatus või täpsustus väljale „Lähteülesande täiendus või muudatus…” ja klõpsa „Saada”.",
            "„Manusta” lisab dokumente ja pakub esmalt lähteülesande enda faile jaotises „Lähteülesandes”.",
            "Paremklõpsa lähteülesande failil (või vali mitu) ja vali „Lisa täiendus”, et alustada täiendust nende failidega.",
            "Täiendused on vanimast uuemani; need ei teavita kedagi, seega @ on tavaline tekst.",
          ],
        },
        check: {
          title: "Lase Franklinil aidata lähteülesannet kontrollida",
          points: [
            "Klõpsa Franklini ettepanekute juures „Käivita kontroll”; see pole saadaval, kui kontroll on järjekorras või käib.",
            "Franklin kontrollib ka ise pärast üleslaadimist, lähteülesande muudatust, ülesande muudatust või hoone andmete muudatust; paneel näitab põhjust ja aega („Viimane kontroll …”).",
            "Järjekorras oleva kontrolli saad peatada nupuga „Tühista kontroll”; ebaõnnestunud kontroll näitab „Viimane kontroll ebaõnnestus” ja põhjus on näha kursorit peale viies.",
            "Teisel lehel olles ilmub teade „Franklin lõpetas lähteülesande kontrolli” koos nupuga „Vaata”, mis toob sind tagasi.",
            "Kontroll aitab märgata võimalikke probleeme, kuid ei tõenda, et lähteülesanne on täielik või vastuoludeta.",
          ],
        },
        suggestions: {
          title: "Loe Franklini ettepanekuid",
          points: [
            "Igal ettepanekul on tõsiduse täpp (Kõrge, Keskmine, Madal, Info); klõpsa sellel, et avada „Mida Franklin leidis”, „Lähteülesandes” ja „Tõendid”.",
            "Klõpsa viitel, et avada viidatud dokument selle lehekülje, lehe või mudelielemendi juurest.",
            "Pea iga ettepanekut vihjeks: ava selle tõendid ja otsusta ise.",
            "Vii kursor ettepanekule, et dokumentide nimekirjas tõsteks esile failid, millele see viitab.",
            "„Minimeeri” muudab paneeli Franklini logoks, mis loeb avatud ettepanekuid ja pöörleb kontrolli ajal.",
          ],
        },
        resolveSuggestion: {
          title: "Võta ettepanek vastu või loobu sellest",
          points: [
            "„Lisa lähteülesandesse” avab ettepaneku muutmiseks; „Lisa lähteülesandesse” dialoogis salvestab selle täiendusena, mille autoriks on „Franklin · kinnitas” sina.",
            "„Loobu ettepanekust” paneb selle kõrvale; loobutud ettepaneku saad tagasi nupuga „Ava uuesti”.",
            "Lahendatud ettepanekud liiguvad jaotisse „Lahendatud”, sealhulgas need, mis on „Lahendatud lähteülesande muudatusega”.",
          ],
        },
        suggestedIssue: {
          title: "Loo soovitatud ülesanne",
          points: [
            "Mõnel ettepanekul on „Soovitatud ülesanne” koos väljadega „Miks”, „Distsipliinid” ja „Soovitatud vastutajad”, mis on võetud kontaktide lehelt.",
            "Klõpsa „Loo see ülesanne”, et avada ettepaneku põhjal täidetud ülesandevorm.",
            "Pärast loomist viitab ettepanek sellele kui „Ülesanne #…”.",
          ],
        },
        additionThread: {
          title: "Vasta täiendusele, muuda seda või loo sellest ülesanne",
          points: [
            "Täienduse all alustab „Vasta” arutelu ja „Muuda” muudab selle teksti ja manuseid.",
            "„Kustuta” eemaldab selle koos vastustega; kinnitatud versioonidesse jääb selle koopia.",
            "„Loo ülesanne” loob sellest ülesande ja seob selle kui „Ülesanne #…”.",
          ],
        },
        confirm: {
          title: "Kinnita versioon",
          points: [
            "„Kinnita versioon …” ilmub, kui on midagi salvestada: esimese versiooni jaoks failid või täiendused, hiljem kinnitamata muudatused.",
            "Dialoog loetleb, mis on viimasest versioonist saadik muutunud; lisa „Muudatuse märkus” selle kohta, mis muutus ja miks.",
            "Kui lahkud lehelt pärast lähteülesande muutmist, küsitakse „Kas kinnitad enne lahkumist versiooni …?” — muudatused on igal juhul salvestatud.",
          ],
        },
        versions: {
          title: "Vaata või võrdle varasemaid versioone",
          points: [
            "Versioonisakid on vanimast uusimani, viimane on „Praegune”; vii kursor sakile, et näha, kes selle kinnitas, failide arvu ja märkust.",
            "„Praegune” on kollane ja loeb kinnitamata muudatusi; sildid nagu „Uus”, „Muudetud” ja „Eemaldatud: …” märgivad neid nimekirjades.",
            "Versioonil klõpsates näed seda ainult vaatamiseks; „Tagasi praegusele” viib tagasi.",
            "Võrdlusikoon avab „Võrdle versioone” väljadega „Alates” ja „Kuni”; märgi „Näita muutmata”, et näha kõike.",
          ],
        },
        history: {
          title: "Lähteülesande ajalugu",
          points: [
            "„Lähteülesande ajalugu” loetleb kõik kinnitatud ja kustutatud versioonid koos tegija, aja ja muudatuse märkusega.",
            "Klõpsa seal kinnitatud versioonil, et seda vaadata.",
          ],
        },
        deleteVersion: {
          title: "Kustuta versioon",
          points: [
            "Versiooni vaadates klõpsa „Kustuta versioon …” või kasuta „Lähteülesande ajaloos” selle kõrval olevat kustutamise nuppu.",
            "Kaob ainult selle versiooni kirje; faile ja täiendusi see ei muuda.",
            "Kustutamine jääb ajalukku ja selle numbrit uuesti ei kasutata.",
          ],
        },
      },
    },
    contacts: {
      intro:
        "Kes selle hoone projektides töötavad, kuidas nendega ühendust võtta ja mille eest keegi vastutab. Projekti liikmed ilmuvad siia ise ja kõiki teisi saab lisada väliste kontaktidena. Projektivaates näed ühe projekti kontakte; hoonevaates on igal projektil oma jaotis ning organisatsiooni omanikud ja administraatorid on ühe korra jaotises „Kõik projektid”. Vastutusalad mõjutavad ka ülesannete lehti — filtrit „Minu vastutusalad” ja soovitatud vastutajaid.",
      items: {
        add: {
          title: "Lisa kontakt",
          points: [
            "Klõpsa üleval „Lisa kontakt” või hoonevaates projekti jaotise juures.",
            "Sisesta nimi, „Ametikoht”, „Ettevõte”, vastutusalad ja märkmed; hoonevaates vali esmalt projekt.",
            "Lisa kuni 10 telefoninumbrit ja 10 e-posti aadressi, igaühele soovi korral silt, nt mobiil.",
          ],
        },
        memberDetails: {
          title: "Lisa projekti liikme andmed",
          points: [
            "Liikmed on loendis koos konto e-postiga ka siis, kui keegi pole veel andmeid lisanud.",
            "Klõpsa nende real + („Lisa andmed”), et lisada telefoninumbreid, ametikohta, vastutusalasid ja märkmeid; see on ridadel, mida saad muuta.",
            "Liikme nimi tuleb tema Franklini profiilist ja seda ei saa siin muuta.",
          ],
        },
        search: {
          title: "Otsi",
          points: [
            "Kirjuta kasti „Otsi kontakte…” — see otsib nimedest, ametikohtadest, ettevõtetest, e-posti aadressidest, telefoninumbritest, siltidest ja märkmetest.",
            "Telefoninumbreid võrreldakse ainult numbrite järgi, nii et 5551234 leiab ka +372 555 1234.",
          ],
        },
        filter: {
          title: "Filtreeri vastutusala järgi",
          points: [
            "Klõpsa „Vastutusalad” ja vali üks või mitu eriala; alles jäävad kõik, kes vastutavad mõne neist eest.",
            "„Tühjenda” eemaldab filtri.",
            "Hoonevaates otsides või filtreerides peidetakse projektid, kus vasteid pole.",
          ],
        },
        edit: {
          title: "Muuda või kustuta kontakt",
          points: [
            "Ava rea ⋯ menüü ja vali „Muuda” või „Kustuta”; see on ainult kirjetel, mida saad muuta.",
            "Liikme kirje kustutamine eemaldab ainult tema kohta sisestatud andmed — tema juurdepääsu see ei mõjuta.",
          ],
        },
        copy: {
          title: "Helista, kirjuta või kopeeri",
          points: [
            "Klõpsa telefoninumbril, et helistada, või e-posti aadressil, et kirjutada.",
            "Vii kursor väärtusele ja klõpsa kopeerimisikoonil, et see kopeerida.",
          ],
        },
        badges: {
          title: "Loe rea silte",
          points: [
            "„Väline” tähistab inimest, kellel pole Franklini kontot; „Sina” tähistab sinu enda rida.",
            "„Juurdepääs puudub” tähistab inimest, kellel pole enam juurdepääsu; tema rida on hall.",
            "Märkmete all olev „Lisas …” näitab, kes andmed sisestas.",
          ],
        },
        sections: {
          title: "Sirvi projekte hoonevaates",
          points: [
            "Iga projekt on eraldi jaotis koos arvuga „Kontakte: N”; klõpsa selle nimel, et jaotis ahendada või laiendada.",
            "Organisatsiooni omanikud ja administraatorid on loendis ühe korra, jaotises „Kõik projektid”, mitte igas projektis.",
          ],
        },
      },
    },
    model: {
      intro:
        "Vaata hoone IFC mudeleid 3D-s. Laadi üks või mitu mudelit, uuri iga elemendi omadusi, tee lõikeid, filtreeri korruse, distsipliini või klassi järgi ja võrdle kahte versiooni, et näha, mis lisati, eemaldati või muutus. Elementidele saad siduda ülesandeid koos salvestatud vaatega ning ülesande seotud element avaneb siia tagasi Ülesannete lehe ülesandepaneelist. Mudelid tulevad Dokumentides üles laaditud .ifc-failidest.",
      items: {
        models: {
          title: "Vali mudelid",
          points: [
            "Ava paremal üleval „Vali mudelid”, märgi üks või mitu faili ja klõpsa „Rakenda”; mitu mudelit laaditakse ühte vaatesse.",
            "Kui failil on varasemaid versioone, klõpsa selle versioonimärgil („v2 ⌄”), et need kuvada ja üks neist valida.",
            "Silma ikoon („Peida 3D vaates” / „Näita 3D vaates”) peidab laaditud mudeli seda eemaldamata.",
            "Kui faile on üle 10, avab „Sirvi kõiki … IFC faile” täieliku sirvija; kui mudeleid veel pole, viib „Mine dokumentide juurde” .ifc-faili üles laadima.",
          ],
        },
        inspect: {
          title: "Uuri elementi",
          points: [
            "Klõpsa elemendil 3D-vaates, et avada „Omadused”: tüüp, nimi, GUID, kõrgus, kõik omadused ning materjalid koos kihtidega.",
            "„Tõsta esile sarnased elemendid” tõstab esile kõik sama IFC-klassi elemendid; uus klõps lülitab selle välja.",
            "Paremklõps elemendil pakub sama tegevust ja rohkem.",
          ],
        },
        spatialTree: {
          title: "Sirvi ruumistruktuuri",
          points: [
            "Klõpsa „Ruumistruktuur”, et näha iga mudeli hoonet, korruseid ja elemendiklasse puuna.",
            "Klõpsa korrusel, et tõsta esile kõik sellel olev ja suunata kaamera sinna.",
            "Klõpsa klassil, et tõsta esile kõik selle elemendid sellel korrusel, või elemendil, et see valida; nool laiendab rida.",
          ],
        },
        section: {
          title: "Tee lõige",
          points: [
            "Klõpsa „Lõikekast (kõrgus- ja lõikevaated)” ning lohista kasti noolt või liugureid või sisesta piirid meetrites väljadele „Kõrguslõige (kõrgus)”, „Lõige (laius)” ja „Lõige (sügavus)”.",
            "„Eralda korrus” piirab kasti ühele korrusele; „Kogu hoone” taastab selle.",
            "Paremklõps elemendil → „Lõikekast ümber selle” või paremklõps pinnal → „Lõika siit” teeb kaldlõike, mis kuvatakse jaotises „Kaldlõiked”.",
            "Paneeli avamine ei lõika midagi enne, kui seda palud; punane X nupul eemaldab lõike.",
          ],
        },
        sectionOptions: {
          title: "Kohanda lõiget",
          points: [
            "„Peata lõige” näitab tervet mudelit ja säilitab lõike; „Jätka lõiget” toob selle tagasi.",
            "„Peida pidemed” eemaldab nooled; „Joonda korrustega” joondab kõrguslõike korruste tasemetega.",
            "„Pealtvaade”, „Külgvaade” ja „Eestvaade” suunavad kaamera mööda iga lõiget.",
            "„Lähtesta kast” taastab terve mudeli; „Eemalda lõige” eemaldab lõike; paneeli peitmisel lõige jääb alles.",
          ],
        },
        filters: {
          title: "Filtreeri mudelit",
          points: [
            "Klõpsa „Filtrid” ja vali „Korrus”, „Distsipliin” või „Klass”; märgi „Näita ruume”, et kuvada ruumid.",
            "Paneeli „Tühjenda” või punane X nupul eemaldab kõik filtrid.",
            "Võrdlemisel kitsendavad samad filtrid võrdlust.",
          ],
        },
        issueFromElement: {
          title: "Loo elemendile ülesanne",
          points: [
            "Vali element ja klõpsa jaotises „Elemendi ülesanded” „Loo sellest elemendist ülesanne” või paremklõps → „Loo ülesanne”.",
            "Ülesanne seotakse elemendiga ja salvestab praeguse vaate: mudelid, kaamera ja lõike.",
            "See lisatakse mudeli projekti; kui sul seal ülesannete õigust pole, palutakse sul ligipääsu küsida.",
          ],
        },
        modelIssues: {
          title: "Mudeli ülesanded",
          points: [
            "„Mudeliga seotud ülesanded” loetleb kõik laaditud mudelitega seotud ülesanded koos numbri, vastutajate ja staatusega; „Elemendi ülesanded” näitab ainult valitud elemendi omi.",
            "„Ava ülesanne” avab ülesande siinsamas vaaturist lahkumata.",
            "„Taasta salvestatud vaade” toob tagasi ülesandega salvestatud mudelid, kaamera ja lõike; „Mine elemendi juurde” suunab vaate selle elemendile.",
          ],
        },
        compare: {
          title: "Võrdle kahte versiooni",
          points: [
            "Märgi „Vali mudelid” all täpselt kaks ja klõpsa „Võrdle erinevusi”; sama faili kahte versiooni saab ainult võrrelda, mitte koos laadida.",
            "Üleval valivad „Vanem” ja „Uuem”, kumba mudelit näidatakse; „Vaheta fail” vahetab kumbagi poolt teise faili või versiooni vastu.",
            "„Vaheta vanem / uuem” pöörab need ümber; „Lõpeta võrdlus” naaseb tavavaatesse.",
            "Aadress säilitab paari, nii et link avab sama võrdluse uuesti.",
          ],
        },
        compareChanges: {
          title: "Vaata muudatused üle",
          points: [
            "Paneel „Muudatused” loetleb elemendid: „Lisatud” (roheline), „Eemaldatud” (punane) ja „Muudetud” (merevaik); muutmata on hallid.",
            "„Rühmita” klassi, korruse või distsipliini järgi või kasuta välja „Otsi elemente…”.",
            "Klõpsa muudatusel, et näha selle omaduste, materjalide ja atribuutide „Enne” ja „Pärast”.",
            "„Eralda muudatused” peidab muutmata elemendid; avad ja muud kehata elemendid loevad muudatusteks, kuid neid ei saa 3D-s kuvada.",
          ],
        },
        navigate: {
          title: "Liigu ringi",
          points: [
            "Lohista pööramiseks, keri suumimiseks.",
            "Pärast vaatele klõpsamist liigutavad kaamerat klahvid W A S D või nooleklahvid.",
            "Navigeerimisnupud pakuvad „Linnulennuvaade”, „Külgvaade (vahetab 4 külje vahel)” ja „Mahuta mudel vaatesse”.",
            "„Peida navigeerimine” ja „Peida juhtnupud” peidavad nupud.",
          ],
        },
        screenshot: {
          title: "Salvesta ekraanipilt",
          points: [
            "Kaamera ikoon („Laadi ekraanipilt alla”) salvestab praeguse vaate PNG-failina.",
            "Paremklõps mudelis → „Tee ekraanipilt” teeb sama.",
          ],
        },
      },
    },
    drawings: {
      intro:
        "Vaata projekti DWG-jooniseid brauseris, originaalvärvides. Ava üks joonis, et seda lugeda, või kaks — tavaliselt kaks versiooni —, et näha, mis lisati ja mis eemaldati. Saad mõõta, kihte peita, PDF-i eksportida ja kinnitada ülesandeid kohta, mida need puudutavad; need on tavalised projekti ülesanded ja paistavad ka lehel Ülesanded. Näed visuaalset eelvaadet, seega üksikasjalikuks kontrolliks kasuta lähte-DWG-faili.",
      items: {
        open: {
          title: "Ava joonis",
          points: [
            "Klõpsa „Vali joonis…”, märgi üks joonis ja klõpsa „Rakenda”.",
            "Vanemad versioonid on praeguse all: klõpsa versioonimärgil, et „Näita vanemaid versioone”.",
            "Kui jooniseid on üle 10, jaotub loend rühmadeks „Valitud”, „Hiljutised” ja „Viimati lisatud” ning „Sirvi kõiki … DWG faile” avab kogu kaustavaate.",
            "Lehel Dokumendid vali üks DWG ja klõpsa „Vaata joonist”. Avatud joonised jäävad lehe aadressi, nii et värskendus, Tagasi või jagatud link avab sama vaate.",
          ],
        },
        compare: {
          title: "Võrdle kahte joonist",
          points: [
            "Ava „Vali joonis…”, märgi kaks joonist ja klõpsa „Võrdle erinevusi”. Kolmandat märgistust ei lubata — piir on kaks.",
            "Franklin otsustab, kumb on vanem: sama faili puhul versiooninumbri, muidu üleslaadimise kuupäeva järgi. Valija märgib need „Vanem” ja „Uuem”.",
            "„Vaheta vanem / uuem” pöörab need ümber; „Lõpeta võrdlemine” jätab alles ainult vanema joonise.",
            "Lehel Dokumendid vali kaks DWG-d ja klõpsa „Võrdle jooniseid”.",
          ],
        },
        modes: {
          title: "Vali, kuidas muudatusi näidata",
          points: [
            "Võrdlemise ajal vali ülaosa nupureast režiim: „Ülekate”, „Ainult muutused”, „Lohista”, „Vilkumine” või „Kõrvuti”.",
            "„Lohista”: veeda punast eraldusjoont üle joonise, et kahe vahel vahetada.",
            "„Vilkumine”: muudatused vilguvad ise sisse ja välja, umbes iga 0,65 sekundi järel.",
            "„Kõrvuti” näitab kahte joonist teineteise kõrval.",
          ],
        },
        legend: {
          title: "Loe, mis muutus",
          points: [
            "Võrdlemise ajal loeb tööriistariba all olev legend, mis on „Lisatud” (roheline) ja „Eemaldatud” (punane); „Muutmata” jooned on hallid.",
            "Kui neid on, loeb „Uuesti joonistatud rida” objekte, mis kustutati ja joonistati uuesti täpselt samasse kohta ja samas stiilis. Joonisel need midagi ei muuda, seega arvestusse neid ei võeta — üksikasjad näed, kui liigud sellele hiirega või klõpsad.",
            "„Kihid” avamine asendab legendi, kuni selle sulged.",
          ],
        },
        navigate: {
          title: "Liigu joonisel",
          points: [
            "Lohista, et nihutada; keri, et suumida kursori suunas, või kasuta nuppe „Suumi sisse” ja „Suumi välja”.",
            "„Mahuta” viib tagasi vaatesse, millega fail salvestati, või kogu joonisele — võrdlemisel mõlemale joonisele.",
            "Päikese/kuu nupp vahetab „Hele” ja „Tume” tausta.",
            "„Peida juhtnupud” voldib tööriistariba kokku; „Näita juhtnuppe” toob selle tagasi.",
          ],
        },
        measure: {
          title: "Mõõda",
          points: [
            "„Joonlaud”: klõpsa kahte punkti, et näha vahemaad.",
            "„Pindala”: klõpsa kolme või enamat nurka, et näha pindala ruutmeetrites.",
            "„Koordinaat”: klõpsa punkti, et näha selle X ja Y millimeetrites.",
            "Tulemus kuvatakse joonise allservas. Esc tühjendab selle; tööriista ajal saab endiselt lohistades nihutada ja nupu uuesti klõpsamine lülitab tööriista välja.",
          ],
        },
        layers: {
          title: "Näita või peida kihte",
          points: [
            "Klõpsa „Kihid” ja eemalda kihilt märge, et see peita; iga rida näitab kihi värvi.",
            "„Kõik” näitab jälle kõiki kihte.",
            "Võrdlemisel tähistab sinine täpp muudatustega kihte ja „Ainult muutunud” näitab ainult neid.",
          ],
        },
        issues: {
          title: "Kinnita ülesanne joonisele",
          points: [
            "Klõpsa „Loo ülesanne” ja siis kohal, kuhu see kuulub — või paremklõpsa kohal ja vali „Loo ülesanne”. Esc tühistab.",
            "Ülesande vorm avaneb nii, et joonis on manustatud (võrdlemisel mõlemad) ja koht salvestatud.",
            "Ülesanne lisatakse joonise projekti ja rühmitatakse lehel Ülesanded selle joonise ülesande alla.",
          ],
        },
        issueMarkers: {
          title: "Vaata joonisel olevaid ülesandeid",
          points: [
            "Avatud joonistele kinnitatud ülesanded paistavad nummerdatud mullidena, mille värv näitab staatust; „Kõrvuti” režiimis mõlemal poolel.",
            "Klõpsa mullil, et ülesanne avada ja seda muuta joonisest lahkumata.",
            "„Peida ülesanded” peidab mullid; „Näita ülesandeid” toob need tagasi.",
          ],
        },
        export: {
          title: "Ekspordi PDF või ekraanipilt",
          points: [
            "„Ekspordi PDF” avab kogu joonise A3-eelvaate.",
            "Klõpsa „Joonista aken” ja siis kahte nurka, et eksportida ainult see ala; „Kogu joonis” võtab jälle kogu joonise.",
            "Klõpsa „Laadi PDF alla”, et see salvestada, või „Tühista”.",
            "„Laadi ekraanipilt alla” salvestab praeguse vaate PNG-pildina.",
          ],
        },
      },
    },
    issues: {
      intro:
        "Kõik projekti ülesanded — tööd, puudused ja küsimused — nimekirjana, Kanban-tahvlina või Gantti ajakavana. Ava ülesanne, et muuta selle välju, arutada seda kommentaarides, lisada dokumente ja märkida kontrollnimekirja punkte tehtuks. Siia jõuavad ka joonisel, mudeli elemendil või dokumendi kommentaaris loodud ülesanded ning „Loo protokoll” teeb ajavahemiku tegevustest PDF-i. „Minu ülesanded” näitab ainult sind puudutavaid, „Teavitused” seda, mis muutus.",
      items: {
        newIssue: {
          title: "Loo ülesanne",
          points: [
            "Klõpsa „Uus ülesanne”: külgpaneelil avaneb mustand, mis ilmub kohe ka loendisse. Kirjuta „Kirjeldus” ning määra staatus, vastutajad, kuupäevad ja distsipliin.",
            "Ülesanne lisatakse projekti, milles töötad; projekti ei pea valima.",
            "Klõpsa „Loo”, vajuta väljaspool tekstivälja Enter või lihtsalt lahku mustandist: see salvestatakse, kui sel on kirjeldus, ja tühi mustand jäetakse kõrvale.",
            "Kirjelduse all valib „Märgi alamülesandeks” ülemülesande ja „Lisa kontrollnimekiri” lisab punktid enne salvestamist; „Lisa Franklini logist” või „Lae üles” lisab dokumente.",
            "Valitud distsipliini eest vastutajad on loendis eespool, pealkirja „Vastutavad nende erialade eest” all.",
            "Kanbanis määrab veeru all olev „+ Lisa ülesanne” selle staatuse; Ganttis määrab rühma real „Lisa siia ülesanne” selle rühma. Mudelis, joonisel või lähteülesandes luuakse ülesanne samade väljadega aknas.",
          ],
        },
        open: {
          title: "Ava ja muuda ülesannet",
          points: [
            "Klõpsa ülesandel, et avada selle paneel; klõpsa uuesti või vajuta Esc, et see sulgeda. Paneeli vasakut serva lohistades muudad selle laiust.",
            "Klõpsa pealkirjal, et seda muuta, ning muuda staatust, vastutajaid, kuupäevi ja „Sildid” kohapeal. Muuta saavad ainult need, kes tohivad selle projekti ülesandeid hallata.",
            "„+” menüü lisab kontrollnimekirja või alamülesande või muudab selle ülesande alamülesandeks; kella ikoon avab „Ülesande ajalugu”.",
            "Seotud mudeli elemendid on jaotises „Elemendid”; klõpsa elemendil, et avada 3D-mudel selle kohal.",
          ],
        },
        views: {
          title: "Nimekiri, Kanban või Gantt",
          points: [
            "Nimekiri: rühmitatud read staatuse, distsipliini, vastutajate, tähtaja ning kommentaaride ja dokumentide arvuga; muuda lahtreid kohapeal.",
            "Kanban: lohista kaarte staatuse veergude vahel või veeru sees üles ja alla.",
            "Gantt: lohista riba, et seda nihutada, või selle otsi, et muuta kuupäevi, ning vaheta mõõtkava: Päev, Nädal või Kuu.",
            "Gantti muudatused ootavad salvestamata muudatustena, kuni klõpsad „Kinnita” või „Loobu”; lehelt lahkudes küsitakse enne.",
          ],
        },
        filters: {
          title: "Filtreeri, sorteeri ja otsi",
          points: [
            "„Filtrid” kitsendab staatuse, valiku „Ainult tähtaja ületanud”, vastutaja, distsipliini, „Seotud dokumentidega” või „Kommentaaridega” järgi; aktiivsed filtrid on kõrval kiipidena.",
            "„Sorteeri” rühmitab nimekirja ja Gantti loomise kuupäeva, distsipliini, staatuse, vastutaja või tähtaja järgi.",
            "Otsingukast otsib ülesannete pealkirjadest.",
            "„Minu vastutusalad” ilmub, kui sul on Kontaktide lehel vastutusalad, ja filtreerib nende järgi.",
          ],
        },
        bulkEdit: {
          title: "Paremklõps ja hulgimuutmine",
          points: [
            "Paremklõpsa ülesandel, et muuta selle staatust, vastutajaid, distsipliini või kuupäevi, „Teisalda projekti”, „Loo alamülesanne…” või „Lisa dokument”.",
            "Nimekirjas märgi rea alguses olev ruut; Shift-klõps märgib vahemiku.",
            "Ilmuval ribal rakendab „Tegevused” staatuse, vastutajad, distsipliini, kuupäevad või projekti vahetuse kõigile märgitud ülesannetele.",
            "„Küsi Franklinilt” lisab ülesanded vestlusesse, et saaksid nende kohta küsida.",
          ],
        },
        comments: {
          title: "Kommenteeri ja maini",
          points: [
            "Kirjuta väljale „Lisa kommentaar…” ja vajuta Enter või „Saada”; kommentaarile saab lisada dokumente.",
            "Kirjuta @ või kasuta nuppu „Maini kedagi”, et projekti liiget teavitada.",
            "„Vasta” tsiteerib kommentaari ja mainib selle autorit; „Muuda” muudab sinu enda kommentaare.",
          ],
        },
        attachments: {
          title: "Lisa dokumente",
          points: [
            "Ülesande jaotises „Dokumendid” seob „Lisa” → „Lisa Franklini logist” olemasoleva faili ja „Lae üles” lisab uued.",
            "Üles laaditud failid salvestatakse projekti kausta „Issue Attachments”.",
            "Pildid ja PDF-id on galeriina; klõpsa failil, et see avada, või „Dokumendid”, et jaotis kokku voltida.",
          ],
        },
        statuses: {
          title: "Staatused",
          points: [
            "Igal projektil on Töös, Lahendatud ja Suletud; muuda staatust real, paneelis või Kanbani kaarti lohistades.",
            "Kui valitud on üks projekt, lisa oma staatus nupuga „Uus staatus” — staatuse valikus, „Filtrid” all või tahvli viimase veeruna.",
            "Vii kursor valikus oma staatusele, et seda muuta või kustutada; kasutusel olevat staatust kustutada ei saa. Oma veeru pidet lohistades muudad tahvli järjekorda.",
          ],
        },
        checklists: {
          title: "Kontrollnimekirjad",
          points: [
            "Avatud ülesandes klõpsa „+” → „Lisa kontrollnimekiri” või paremklõpsa ülesandel → „Lisa kontrollnimekiri”.",
            "Kirjuta väljale „Lisa punkt”, märgi punktid tehtuks, klõpsa punktil, et seda ümber nimetada, ja lohista järjekorra muutmiseks.",
            "Edenemine, näiteks 2/5, on näha ülesande real ja Kanbani kaardil.",
          ],
        },
        dependencies: {
          title: "Sõltuvused",
          points: [
            "Avatud ülesande jaotises „Sõltuvused” lisa, mida see „Ootab” ja mida see „Mõjutab”; mõlemad ülesanded peavad olema samas projektis.",
            "Vali seos (nt „Lõpp → algus”), nihe päevades ning „Range” (liigub koos eelnevaga) või „Paindlik” (ainult hoiatab).",
            "Ganttis lohista riba otsa punktist teisele ribale, et need siduda; Esc tühistab.",
            "Kui muudatus nihutab sõltuvaid ülesandeid, vali „Uuenda ajakava” või „Jäta kuupäevad samaks”; teate „Võta tagasi” taastab endise.",
          ],
        },
        snapshots: {
          title: "Ajakava salvestused",
          points: [
            "Kui valitud on üks projekt, ava Gantt ja klõpsa mõõtkava kõrval järjehoidja ikooni, et „Salvesta ajakava”; kinnita või loobu enne salvestamata muudatustest.",
            "Selle kõrval olev kella ikoon avab „Ajakavade ajalugu”; vali salvestus, et seda ainult vaadata, „Nimeta ümber” või kustuta see.",
            "„Võrdle tänasega” näitab, mis on pärast seda nihkunud, lisandunud või kadunud; „Tagasi praeguse ajakava juurde” väljub salvestusest.",
          ],
        },
        protocol: {
          title: "Loo protokoll",
          points: [
            "Klõpsa „Loo protokoll” ja vali ajavahemik: Täna, Sel nädalal, Sel kuul või kohandatud ajavahemik.",
            "Eemalda linnuke ülesannetelt, mida ei lisata, seejärel vali, mida dokument sisaldab — kokkuvõte, ülesannete tabel, tegevuste logi — ja lisa oma lõike.",
            "Jaotises „Manused” lisab „Lisa” faile Franklinist või sinu arvutist; märgi ülesannete valikute all „Manused”, et lisada ka valitud ülesannete failid. Pildid prinditakse ja PDF-id lisatakse lehekülgede kaupa; muud failid on loetletud nime järgi. Arvutist lisatud failid lähevad ainult PDF-i, mitte projekti.",
            "„Kujundus” valib välimuse — „Klassikaline”, „Kaasaegne” või „Kompaktne”; sisu jääb samaks.",
            "Vali PDF-i keel, vaata „Eelvaade” üle ja klõpsa „Ekspordi PDF”.",
            "PDF laaditakse alla; „Salvesta projekti” paneb selle ka projekti kausta.",
          ],
        },
      },
    },
    myIssues: {
      intro:
        "Sinu isiklik vaade hoone ülesannetele: sulle määratud, sinu loodud või sind mainivad ülesanded ning tähtaja ületanud tööd eraldi sakil. Leht järgib külgribal valitud projekti ning kasutab sama nimekirja, tahvlit, detailpaneeli ja menüüsid nagu „Ülesanded”. Punane täpp külgriba kirje „Minu ülesanded” juures tähendab, et keegi on sind kommentaaris @mainimisega märkinud ja sa pole seda veel lugenud.",
      items: {
        tabs: {
          title: "Vaheta sakkide Vastutaja, Loodud, Mainimised ja Tähtaeg möödas vahel",
          points: [
            "„Vastutaja”: ülesanded, kus oled vastutaja. „Loodud”: sinu loodud ülesanded. „Mainimised”: ülesanded, kus sind on kommentaaris @mainitud.",
            "„Tähtaeg möödas”: sulle määratud töös olevad ülesanded, mille tähtaeg on möödas. Selle punane arv on näha igal sakil.",
            "Sakk määrab, kelle ülesandeid näed, seega filtrites siin vastutaja valikut pole.",
          ],
        },
        open: {
          title: "Ava ülesanne",
          points: [
            "Klõpsa ülesandel, et avada selle detailpaneel nimekirja kohal; uus klõps sulgeb selle.",
            "Kommenteeri väljal „Lisa kommentaar…” ja kirjuta @, et kedagi mainida.",
            "Ülesande avamine märgib sinu lugemata mainimised selles loetuks. Seni on selle kommentaaride arvu juures punane täpp.",
          ],
        },
        newIssue: {
          title: "Loo ülesanne",
          points: [
            "Klõpsa „Uus ülesanne”. Ülesanne lisatakse projekti, milles töötad; projekti ei pea valima.",
            "Kanban-tahvlil avab veeru all olev „Lisa ülesanne” vormi, kus selle veeru staatus on juba valitud.",
          ],
        },
        layout: {
          title: "Vali Nimekiri või Kanban",
          points: [
            "„Nimekiri” näitab ridu veergudega; klõpsa veeru pealkirjal, et selle järgi sortida.",
            "„Kanban” näitab iga ülesannet kaardina staatuse veergudes; lohista kaarti, et staatust muuta.",
            "Sakk „Tähtaeg möödas” on alati nimekiri.",
          ],
        },
        filters: {
          title: "Filtreeri ja otsi",
          points: [
            "„Filtrid” kitsendab staatuse, distsipliini, seotud dokumentide või kommentaaride järgi; iga aktiivne filter on eemaldatav kiip.",
            "Kirjuta väljale „Otsi ülesandeid…”, et otsida ülesande tekstist.",
            "Kui filtrid peidavad osa sinu ülesandeid, ilmub „… ülesannet peidetud filtritega” koos nupuga „Tühjenda filtrid”.",
          ],
        },
        myDisciplines: {
          title: "Näita ainult oma vastutusalasid",
          points: [
            "„Minu vastutusalad” seab distsipliini filtriks sinu vastutusalad selles projektis; uus klõps eemaldab selle.",
            "Nupp ilmub alles siis, kui sinu vastutusalad on Kontaktide lehel määratud.",
          ],
        },
        sort: {
          title: "Sordi ja rühmita nimekirja",
          points: [
            "„Sorteeri” rühmitab nimekirja „Loomise kuupäev”, „Distsipliin”, „Staatus”, „Vastutaja” või „Tähtaeg” järgi, iga rühm oma pealkirjaga.",
            "See on saadaval ainult nimekirjas; Kanbani veerud on juba staatuse järgi rühmitatud.",
          ],
        },
        quickEdit: {
          title: "Muuda otse realt või kaardilt",
          points: [
            "Klõpsa rea staatusel, distsipliinil, vastutajatel või tähtajal, et seda kohe muuta.",
            "Paremklõps ülesandel pakub valikuid „Muuda kirjeldust”, „Staatus”, „Vastutajad”, „Alguskuupäev”, „Tähtaeg”, „Teisalda projekti”, „Loo alamülesanne…”, „Lisa kontrollnimekiri” ja „Küsi Franklinilt”.",
          ],
        },
        bulk: {
          title: "Muuda korraga mitut ülesannet",
          points: [
            "Nimekirjas märgi ülesannete kõrval olevad kastid; Shift+klõps valib kõik kahe märke vahel olevad ülesanded.",
            "Ava ilmuval ribal „Tegevused”, et määrata kõigile staatus, vastutajad, distsipliin, kuupäevad või projekt, või „Küsi Franklinilt” nende kohta.",
          ],
        },
      },
    },
    notifications: {
      intro:
        "Voog kõigest, mis on toimunud selle hoone ülesannetes, millele sul on ligipääs, uusimad eespool ja päevade kaupa: loodud või kustutatud ülesanded ning muudatused pealkirjades, staatustes, kuupäevades, vastutajates, failides, IFC-elementides, kommentaarides, kontrollnimekirjades ja sõltuvustes. Voog järgib külgribal valitud projekti. Lehe avamine märgib voo nähtuks ja kustutab punase täpi külgriba kirje „Teavitused” juurest.",
      items: {
        open: {
          title: "Mine ülesande juurde",
          points: [
            "Iga kirje näitab, kes mida tegi, ülesande numbrit ja pealkirja ning kuupäeva ja kellaaega.",
            "Klõpsa kirjel, et avada see ülesanne lehel „Ülesanded”.",
          ],
        },
        filter: {
          title: "Filtreeri voogu",
          points: [
            "Klõpsa „Filtrid” ja vali „Tegevuse tüüp”, „Isik”, „Lugemata” või „Ajavahemik”.",
            "„Tegevuse tüüp” hõlmab näiteks „Staatus”, „Kuupäevad”, „Kommentaarid”, „IFC-elemendid” ja „Kontrollnimekiri”; „Isik” on see, kes muudatuse tegi.",
            "„Ajavahemik” pakub valikuid „Täna”, „Viimased 7 päeva” ja „Viimased 30 päeva”. Iga aktiivne filter on eemaldatav kiip.",
          ],
        },
        unread: {
          title: "Vaata, mis on uut",
          points: [
            "Punane täpp külgriba kirje „Teavitused” juures süttib teiste tegevuse peale, mis on toimunud pärast seda, kui sa selle lehe viimati avasid.",
            "„Ainult lugemata” jätab alles ainult selle tegevuse. Lehe avamine loetakse külastuseks, seega näitab see, mis on lisandunud pärast lehe avamist.",
          ],
        },
        older: {
          title: "Laadi vanemaid tegevusi",
          points: [
            "Voog laadib korraga 50 kirjet ja toob juurde, kui kerid lõpu poole.",
            "All olev „Näita rohkem” teeb sama klaviatuurilt.",
          ],
        },
        live: {
          title: "Uus tegevus ilmub ise",
          points: [
            "Uued kirjed ilmuvad lehe avatud olles ja ka siis, kui naased vahekaardile, ilma uuesti laadimata.",
            "Juba laaditud kirjed jäävad alles.",
          ],
        },
        email: {
          title: "Saa kokkuvõte e-postiga",
          points: [
            "Franklin saab iga 15 minuti tagant saata kokkuvõtte uutest määramistest, @-mainimistest ja kommentaaridest sinu ülesannetes.",
            "Lülita see sisse või välja valikuga „Saada mulle PM-i tegevuse kokkuvõtte e-kirjad” lehel „Kasutaja seaded”.",
          ],
        },
      },
    },
    settingsPersonal: {
      intro:
        "Sinu profiil ja eelistused. Määra, kuidas sinu nimi ja pilt teistele paistavad, milliseid e-kirju Franklin saadab ja milliseid vestlusroboti tegevusi tehakse ilma küsimata. Külgribal on ka „Turvalisus”, „Ühendatud rakendused” ja „Kutsed” ning all oleva „Profiil” menüüga saad rakenduse keelt vahetada.",
      items: {
        profile: {
          title: "Muuda oma andmeid",
          points: [
            "Muuda välju „Eesnimi”, „Perekonnanimi”, „E-post”, „Telefoninumber”, „Ametinimetus” ja „Ettevõte”.",
            "Ees- ja perekonnanimi on kohustuslikud.",
            "Klõpsa „Salvesta muudatused”; „Tühista” taastab viimati salvestatud andmed.",
            "„E-post” muutmisel muudetakse ka sisselogimise e-posti aadressi.",
          ],
        },
        photo: {
          title: "Lisa profiilipilt",
          points: [
            "Klõpsa oma avataril („Lae üles”) ja vali kuni 2 MB PNG-, JPEG- või WebP-pilt.",
            "Aknas „Kohanda pilti” lohista pilt paika, suurenda liuguriga ja klõpsa „Salvesta”.",
            "Pilt salvestub kohe; „Eemalda foto” võtab selle maha.",
          ],
        },
        avatarColour: {
          title: "Vali avatari värv",
          points: [
            "Vali värvinupp või „Kohandatud värv”, et sisestada mis tahes heksavärv.",
            "Värvi kasutatakse sinu initsiaalide avataril, kui sul pole pilti.",
            "See salvestub nupuga „Salvesta muudatused”, mitte eraldi.",
          ],
        },
        notifications: {
          title: "Vali e-posti teavitused",
          points: [
            "„Saada mulle PM-i tegevuse kokkuvõtte e-kirjad”: iga 15 minuti järel kokkuvõte uutest määramistest, @-mainimistest ja kommentaaridest sinu ülesannetel.",
            "„Saada mulle sõnumitahvli teavitused”: e-kiri, kui keegi postitab projekti sõnumitahvlile, mida sa näed.",
            "Eemalda linnuke, et neid mitte saada, ja klõpsa „Salvesta muudatused”.",
          ],
        },
        chatbot: {
          title: "Luba Franklinil küsimata tegutseda",
          points: [
            "Vaikimisi näitab vestlusrobot enne sinu andmete muutmist kinnituskaarti.",
            "Jaotises „Vestlusroboti seaded” lülita sisse „Uuenda hoone andmeid”, „Loo ülesandeid”, „Uuenda ülesandeid”, „Kommenteeri ülesandeid”, „Lisa faile kaustadesse” või „Kinnita dokumente”, et kaart vahele jätta.",
            "Iga lüliti salvestub kohe; lülita välja, et sinult uuesti küsitaks.",
            "Kui märgid kaardil enne kinnitamist „Luba see tegevus alati”, lülitub see sinu jaoks sisse. Mõne tegevuse puhul on selle asemel „Luba selle vastuse lõpuni”, mis kehtib ainult seni, kuni Franklin vastuse lõpetab.",
            "Nii tehtud kinnitused salvestatakse endiselt sinu nimele.",
          ],
        },
        language: {
          title: "Vaheta keelt",
          points: [
            "Ava külgriba allosas „Profiil”.",
            "Vali „English” või „Eesti”; linnuke näitab valitud keelt.",
          ],
        },
      },
    },
    settingsSecurity: {
      intro:
        "Hoia oma konto turvalisena. Siin saad muuta parooli, millega sisse logid. Väljalogimiseks kasuta külgriba allosas olevat „Profiil” menüüd.",
      items: {
        password: {
          title: "Muuda parooli",
          points: [
            "Sisesta uus parool väljale „Uus parool” ja uuesti väljale „Kinnitage parool”.",
            "Parool peab olema vähemalt 6 tähemärki ja mõlemad sisestused peavad ühtima.",
            "Klõpsa „Uuenda parool”; pärast muutmist väljad tühjenevad.",
          ],
        },
        signOut: {
          title: "Logi välja",
          points: [
            "Ava külgriba allosas „Profiil” ja vali „Logi välja”.",
            "Sind suunatakse tagasi sisselogimislehele.",
          ],
        },
      },
    },
    settingsInvitations: {
      intro:
        "Kutsed organisatsiooniga liitumiseks, mis ootavad sinu vastust. Loendis on ainult sinu e-postile saadetud kutsed, mis on veel ootel ja aegumata. Nõustudes lisandub see organisatsioon külgriba allosas olevasse organisatsioonimenüüsse nende kõrvale, kuhu juba kuulud.",
      items: {
        accept: {
          title: "Nõustu kutsega",
          points: [
            "Iga kutse juures on organisatsioon, e-post, kuhu see saadeti, pakutav roll ja aegumise kuupäev.",
            "Klõpsa „Nõustu”, et selle rolliga liituda.",
          ],
        },
        decline: {
          title: "Keeldu kutsest",
          points: [
            "Klõpsa „Keeldu” ja kinnita aknas „Kas keelduda kutsest?”.",
            "Kutse kaob loendist; administraator saab sind hiljem uuesti kutsuda.",
          ],
        },
        switchOrg: {
          title: "Ava organisatsioon, millega liitusid",
          points: [
            "Ava külgriba allosas organisatsioonimenüü; seal on kõik organisatsioonid, kuhu kuulud.",
            "Vali üks, et sellele lülituda ja näha selle hooneid.",
          ],
        },
        missing: {
          title: "Kui kutset pole näha",
          points: [
            "Loend värskeneb, kui sellele vahelehele tagasi tuled.",
            "Aegunud kutseid ei näidata; palu organisatsioonil see uuesti saata.",
            "Teisele e-posti aadressile saadetud kutset siin ei näe.",
          ],
        },
      },
    },
    settingsConnections: {
      intro:
        "Rakendused, mille oled oma kontoga Frankliniga ühendanud, näiteks AI-assistent. Ühendatud rakendus ulatub ainult sinna, kuhu lubavad sinu enda Franklini õigused, ja ainult ühendamisel valitud organisatsioonis. Muudatused ja üleslaadimised, mida see küsib, avanevad eraldi kinnituslehtedel ning siin saad iga rakenduse igal ajal välja lülitada.",
      items: {
        review: {
          title: "Vaata, mida iga rakendus teha saab",
          points: [
            "Iga rakenduse juures on selle organisatsioon ja antud õigused, näiteks „Loe teavet, millele sul on juurdepääs” või „Loo ja muuda teavet”.",
            "„Ühendatud” ja „Viimati kasutatud” näitavad, millal see lisati ja viimati kasutati.",
            "Vanemate ühenduste nägemiseks klõpsa „Laadi rohkem”.",
          ],
        },
        revoke: {
          title: "Tühista rakenduse juurdepääs",
          points: [
            "Klõpsa „Tühista juurdepääs” ja kinnita; ühendus lakkab kohe töötamast.",
            "Rakenduse juures on seejärel „Juurdepääs tühistatud”.",
            "Uuesti kasutamiseks ühenda ja kinnita see rakendusest uuesti.",
          ],
        },
        connect: {
          title: "Ühenda uus rakendus",
          points: [
            "Alusta rakendusest; see suunab sind lehele „Ühenda Frankliniga”.",
            "Vali „Organisatsioon”, märgi antavad „Õigused” ja klõpsa „Luba juurdepääs”.",
            "Ühenda ainult rakendus, mida tunned: rakendus määrab oma nime ise.",
          ],
        },
        approveChange: {
          title: "Kinnita muudatus, mida rakendus küsib",
          points: [
            "Rakendus avab lehe „Vaata taotletud muudatus üle” koos kavandatud muudatuse ja „Kõik taotluse üksikasjad” vaatega.",
            "Klõpsa „Kinnita see muudatus” või „Keeldu”.",
            "Kinnitus kehtib ainult sellele taotlusele ja aegub 15 minuti pärast; Franklin kontrollib enne muutmist sinu õigusi uuesti.",
          ],
        },
        appUpload: {
          title: "Laadi üles rakenduse küsitud fail",
          points: [
            "Rakendus avab lehe „Laadi fail Franklini”, kus on taotletud fail ja sihtkoht.",
            "Klõpsa „Vali fail” ja vali täpselt sama nime ja suurusega fail.",
            "Fail lisatakse uue dokumendina; saad üleslaadimise peatada ja jätkata, valides sama faili uuesti.",
          ],
        },
      },
    },
    orgSettingsGeneral: {
      intro:
        "Sinu organisatsiooni nimi ja logo, nagu neid näevad kõik selle liikmed. Külgribal on teised organisatsiooni lehed: „Kasutajate haldus”, „Kasutus” ning omanikele ja administraatoritele „Arveldus”. Sellele lehele jõuad külgriba allosas oleva organisatsioonimenüü kaudu, valides „Halda organisatsiooni”.",
      items: {
        rename: {
          title: "Nimeta organisatsioon ümber",
          points: [
            "Muuda välja „Organisatsiooni nimi” ja klõpsa „Salvesta muudatused”.",
            "„Tühista” taastab salvestatud nime.",
            "Uus nimi ilmub ka organisatsioonimenüüsse.",
          ],
        },
        logo: {
          title: "Määra logo",
          points: [
            "Klõpsa „Laadi logo üles” (või „Vaheta logo”) ja vali kuni 2 MB PNG-, JPEG- või WebP-pilt.",
            "Sea see paika ja suurenda, seejärel klõpsa „Salvesta”; logo rakendub kohe.",
            "„Eemalda logo” võtab selle maha.",
            "Logo kuvatakse organisatsioonimenüüs ja sinu saadetud kutsete e-kirjades.",
          ],
        },
        switchOrg: {
          title: "Vaheta organisatsiooni",
          points: [
            "Ava külgriba allosas organisatsioonimenüü; linnuke näitab praegust.",
            "Vali teine, et sellele lülituda ja näha selle hooneid.",
          ],
        },
      },
    },
    orgSettingsUsers: {
      intro:
        "Kes sinu organisatsiooni kuuluvad ja mida nad teha saavad. „Organisatsiooni kutsed” näitab ootel ja aegunud kutseid ning „Kasutajarollid” kõiki liikmeid koos rolli ja olekuga. „Omanik” saab hallata administraatoreid ja liikmeid, „Administraator” ainult liikmeid ning omanikku ei saa siin keegi muuta.",
      items: {
        invite: {
          title: "Kutsu kasutaja",
          points: [
            "Klõpsa „Kutsu kasutaja”, sisesta „E-posti aadress” ja vali „Roll”; vaikimisi on valitud „Liige”.",
            "Omanik saab kutsuda „Administraator” või „Liige” rollis kasutaja, administraator ainult liikmeid.",
            "Liikmele märgi jaotises „Projektid, millele liikmel on juurdepääs” vähemalt üks projekt ja eemalda linnuke kaustadelt, mida ta nägema ei peaks.",
            "Klõpsa „Saada kutse”; ta saab lingiga e-kirja.",
          ],
        },
        role: {
          title: "Muuda rolli",
          points: [
            "Klõpsa liikme rolli märgil (sellel on ▾, kui saad seda muuta) ja vali uus roll.",
            "„Administraator” pääseb ligi kõigile projektidele ja organisatsiooni seadetele, „Liige” ainult talle antud projektidele.",
            "Omanike, enda ja sinust kõrgema taseme rolle muuta ei saa.",
          ],
        },
        projectAccess: {
          title: "Määra liikme juurdepääs projektidele",
          points: [
            "„Liige” rollis kasutaja puhul klõpsa kaustaikoonil („Halda projektide juurdepääsu”).",
            "Märgi vasakul projektid; eemalda kaustalt linnuke, et peita see koos alamkaustadega.",
            "Vali projekt ja „Juurdepääsu tase” – „Ainult vaatamine”, „Kaastöötaja” või „Täielik” – või sea lülitid jaotises „Mida ta teha saab” (kuvatakse „Kohandatud”).",
            "„Rakenda kõigile valitud projektidele” kopeerib seaded; klõpsa „Salvesta”.",
          ],
        },
        remove: {
          title: "Eemalda liige",
          points: [
            "Klõpsa tema real prügikasti ikoonil ja kinnita nupuga „Eemalda”.",
            "Ta kaotab kogu juurdepääsu sellele organisatsioonile; tema kontot ei kustutata.",
            "Omanikku, ennast ega sinust kõrgema taseme kasutajat eemaldada ei saa.",
          ],
        },
        invitations: {
          title: "Halda saadetud kutseid",
          points: [
            "„Ootel” kutsete juures on saatja ja aegumise aeg; kasuta „Kopeeri link”, „Saada uuesti” või ⋯ → „Tühista”.",
            "„Aegunud” kutse saab uue lingiga uuesti saata või nupuga „Kustuta” eemaldada.",
            "„Kustuta kõik aegunud” eemaldab kõik aegunud kutsed korraga.",
            "Loend uueneb ise, kui kutse muutub.",
          ],
        },
        members: {
          title: "Vaata liikmete loendit",
          points: [
            "„Kasutajarollid” näitab iga liikme nime, e-posti, rolli ja olekut („Aktiivne” või „Mitteaktiivne”).",
            "Klõpsa „Värskenda”, et loend uuesti laadida.",
          ],
        },
      },
    },
    orgSettingsUsage: {
      intro:
        "Kui palju salvestusruumi iga organisatsiooni hoone paketi piirist kasutab, projektide kaupa. See leht on ainult vaatamiseks. Lisaruumi saamiseks muudab organisatsiooni omanik hoone paketti jaotises „Arveldus”.",
      items: {
        storage: {
          title: "Vaata iga hoone salvestusruumi",
          points: [
            "Iga hoone juures on kasutatud ruum ja piir, riba ning kasutatud protsent.",
            "Piiranguta hoone juures on „Piiramatu”.",
          ],
        },
        limits: {
          title: "Märka hooneid, mille ruum saab otsa",
          points: [
            "„Salvestusruum peaaegu täis” ilmub alates 85% piirist.",
            "„Salvestusruum täis” tähendab, et piir on täis ja sellesse hoonesse ei saa uusi faile üles laadida.",
            "Ruumi vabastamiseks eemalda faile või vii hoone suurema salvestusruumiga paketile.",
          ],
        },
        byProject: {
          title: "Vaata, millised projektid ruumi kasutavad",
          points: [
            "„Salvestusruum projektide kaupa” näitab iga projekti mahtu ja osakaalu hoone piirist.",
            "Arhiveeritud ja peidetud projekte ei näidata.",
            "Projektide vahel jagatud fail loeb iga projekti juures, hoone juures aga ainult korra.",
          ],
        },
        activationPending: {
          title: "Aktiveerimist ootavad hooned",
          points: [
            "Hoone, mille arveldus pole veel kinnitatud, näitab kasutuse asemel teadet.",
            "Lõpeta vajalik makse jaotises „Arveldus” → „Arved” ja proovi siis arvelduse ülevaates aktiveerimist uuesti.",
          ],
        },
      },
    },
    billingOverview: {
      intro:
        "Hooned, mille eest sinu organisatsioonilt sel perioodil arveldatakse, perioodi kokkuvõte ja järgmine makse; arved väljastatakse selle loendi alusel. Igal hoonel on oma pakett ja eemaldatud hooneid saab 30 päeva jooksul taastada. Lehte näevad omanikud ja administraatorid, kuid hooneid saab lisada, muuta, eemaldada ja taastada ainult organisatsiooni omanik. Ettevõtte andmed ja makseviis on lehel „Arveldusandmed” ning varasemad arved lehel „Arved”.",
      items: {
        summary: {
          title: "Vaata käesolevat perioodi",
          points: [
            "„Käesolev periood” näitab kuupäevi ja järelejäänud päevi.",
            "„Tasulised hooned” näitab, mitme hoone eest sel perioodil arveldatakse.",
            "„Igakuine makse” näitab järgmise makse kuupäeva ja summat.",
          ],
        },
        addBuilding: {
          title: "Lisa hoone",
          points: [
            "Klõpsa jaotises „Selle perioodi hooned” nuppu „Lisa hoone”, täida nimi ja aadress ning vali „Pakett”.",
            "„Free” ei vaja maksekaarti; organisatsiooni kohta on lubatud üks Free-hoone.",
            "Tasuline pakett vajab enne salvestatud arveldusandmeid ja makseviisi; aknas on link lehele „Arveldusandmed”.",
            "Kontrolli näidatud hinda ja klõpsa „Nõustun ja lisan hoone”.",
          ],
        },
        planLimits: {
          title: "Vaata hoone paketti ja piiranguid",
          points: [
            "Igal real on hoone pakett ja kuuhind, teenuse periood ja summa.",
            "Paketi kõrval olev „i”-ikoon näitab „Hoone salvestusruum”, „Arhiveerimata projektid”, „Vestlusküsimused kalendrikuus” ja „PM-ülesanded” koos kasutusega.",
          ],
        },
        changePlan: {
          title: "Muuda hoone paketti",
          points: [
            "Ava hoone ⋮ menüü, vali „Muuda paketti”, vali pakett ja klõpsa „Kinnita pakett”.",
            "Piirangud muutuvad pärast kinnitamist; uus hind kehtib järgmisest uuendamisest, selle tsükli eest lisatasu ega tagasimakset pole.",
            "Kuni muudatus on ootel, näitab seda „i”-ikoon ja paketti ei saa uuesti muuta.",
          ],
        },
        removeBuilding: {
          title: "Eemalda hoone",
          points: [
            "Ava hoone ⋮ menüü, vali „Eemalda” ja kinnita nupuga „Eemalda hoone”.",
            "Hoone jääb täielikult kasutatavaks tasutud perioodi lõpuni ja siis selle eest enam tasu ei võeta.",
            "Seejärel saad 30 päeva jooksul selle dokumente alla laadida ja hoone taastada; siis kustutatakse see jäädavalt.",
            "Eemaldamine töötab ka siis, kui organisatsioon on ainult loetav.",
          ],
        },
        restoreBuilding: {
          title: "Taasta eemaldatud hoone",
          points: [
            "„Eemaldatud hooned” näitab, millal iga hoone kasutusaeg lõpeb („Kasutatav kuni”) ja millal see kustutatakse („Kustutamise kuupäev”).",
            "Klõpsa „Taasta”, kontrolli hinda ja klõpsa „Nõustun ja taastan hoone”; tasutud perioodi sees lisatasu pole.",
            "Taastada saab 30 päeva jooksul, kuid mitte siis, kui organisatsioon on ainult loetav või arveldusandmed või makseviis puuduvad.",
          ],
        },
        activation: {
          title: "Lõpeta ootel aktiveerimine",
          points: [
            "Arvelduse kinnitust ootaval hoonel pole veel projekte, vestlusküsimusi, PM-ülesandeid ega üleslaadimisi.",
            "Selle ⋮ menüüs avab „Vaata arvet” lehe „Arved”, kus saad makse lõpetada; seejärel vali „Proovi aktiveerimist uuesti”.",
          ],
        },
        notices: {
          title: "Reageeri arveldusteadetele",
          points: [
            "Ülaosa teated näitavad tähtaja ületanud arvet, ebaõnnestunud kaardimakset, puuduvaid arveldusandmeid või makseviisi, igaühel nupp parandamiseks.",
            "30 päeva tasumata arve muudab organisatsiooni ainult loetavaks: kõik jääb nähtavaks ja allalaaditavaks, kuid hooneid, projekte ega üleslaadimisi lisada ei saa.",
            "Hall nupp näitab kursori viimisel, miks see pole saadaval.",
          ],
        },
        transfer: {
          title: "Vii hoone teise organisatsiooni",
          points: [
            "Kui omanik või haldaja vahetub, saab hoone koos kõigi andmetega eemaldamise asemel üle anda.",
            "Kirjuta aadressil support@frnkln.ai ja tiim korraldab selle.",
          ],
        },
      },
    },
    billingDetails: {
      intro:
        "Ettevõtte andmed, mis trükitakse igale arvele, ja makseviis, millelt arved tasutakse. Need peavad olemas olema enne tasulise hoone lisamist või taastamist. Omanikud ja administraatorid näevad neid; muuta saab ainult organisatsiooni omanik ning administraatorid näevad teadet „Arveldusandmed on ainult loetavad”.",
      items: {
        companyDetails: {
          title: "Uuenda arve andmeid",
          points: [
            "Täida „Ettevõtte nimi”, „Registrikood”, „KMKR number”, „Juriidiline aadress” ja „Arve e-post”.",
            "„Registrikood” on valikuline. KMKR number algab ELi riigikoodiga ja peab vastama selle riigi vormingule.",
            "„Ostutellimuse number” on valikuline ja kuvatakse igal arvel.",
            "Klõpsa „Salvesta andmed”; nupp muutub aktiivseks, kui midagi on muudetud.",
          ],
        },
        paymentMethod: {
          title: "Seadista makseviis",
          points: [
            "Vali jaotises „Makseviis” „Kaart (automaatne)” või „SEPA otsekorraldus (automaatne)”; iga arve tasutakse selle koostamise päeval.",
            "Klõpsa „Seadista makseviis” (või „Muuda”) või „Salvesta ja seadista makseviis”, kui muutsid ka andmeid.",
            "Kaardi- või pangaandmed sisestatakse Stripe'i turvalisel lehel; tagasi jõudes näed teadet „Makseviis salvestatud.”",
            "Makseviisi vahetamisel vana üle ei kandu; seadista ka uus.",
          ],
        },
        continueAdding: {
          title: "Lõpeta hoone lisamine",
          points: [
            "Kui jõudsid siia hoonet lisades, jäävad selle andmed alles.",
            "Kui andmed ja makseviis on salvestatud, viiakse sind tagasi hoone vormile; „Jätka hoone lisamist” teeb sama igal ajal.",
          ],
        },
        notices: {
          title: "Paranda ebaõnnestunud makse",
          points: [
            "„Arve … tasumine ebaõnnestus” ilmub, kui kaardilt ei õnnestunud tasu võtta.",
            "Klõpsa „Uuenda makseviisi” ja seadista toimiv makseviis, muidu muutub organisatsioon 30 päeva pärast arve kuupäeva ainult loetavaks.",
          ],
        },
      },
    },
    billingInvoices: {
      intro:
        "Kõik sinu organisatsioonile väljastatud arved, uusima maksetähtajaga eespool. Igal real on arve number, hõlmatud hoonete arv, periood, maksetähtaeg, makse olek ja summa. Tähtaja ületanud arvetest antakse teada ka loendi kohal oleva teatega.",
      items: {
        download: {
          title: "Laadi arve alla",
          points: [
            "Klõpsa arve kõrval „Laadi alla”, et salvestada selle PDF.",
            "Kui saadaval on ainult Stripe'i veebiarve, avaneb see uuel vahelehel.",
            "Hall nupp tähendab: „Arve PDF ei ole veel saadaval.”",
          ],
        },
        status: {
          title: "Vaata, mis on tasutud",
          points: [
            "„Tasutud” arvete juures on „Tasutud” koos kuupäevaga.",
            "„Tasumata” on tasumata, kuid tähtaeg pole möödas; „Tähtaeg ületatud” on maksetähtaja ületanud.",
            "„Makse ebaõnnestus” tähendab, et automaatne makse lükati tagasi; teised olekud on „Mustand”, „Tühistatud” ja „Maha kantud”.",
            "Automaatselt tasutavate arvete juures on maksetähtaja asemel „Tasutakse koostamisel”.",
          ],
        },
        overdue: {
          title: "Tasu tähtaja ületanud arve",
          points: [
            "Arvelduslehtede ülaosas annab tähtaja ületanud arvest teada „Arve … on tähtaja ületanud”.",
            "Kui see jääb 30 päevaks tasumata, muutub organisatsioon kuni tasumiseni ainult loetavaks.",
          ],
        },
      },
    },
    help: {
      intro:
        "Juhend kõigi Franklini lehtede kohta, ühes kohas seadete all. Alguses on platvormi ülevaade, seejärel iga lehe kirjeldus ja tegevused valdkondade kaupa. Otsing leiab tegevuse igalt lehelt.",
      items: {
        search: {
          title: "Otsi tegevust",
          points: [
            "Kirjuta ülaosas olevasse otsingukasti; see otsib kõigi lehtede tegevuste hulgast.",
            "Sinu sõnu sisaldavad tegevused ilmuvad kohe.",
            "Tähenduselt seotud tegevused on loetletud nende all.",
          ],
        },
        browse: {
          title: "Sirvi juhendit valdkondade kaupa",
          points: [
            "Alusta platvormi ülevaatest.",
            "Iga lehe kirjeldus ja tegevused on rühmitatud selle valdkonna alla.",
          ],
        },
        openPage: {
          title: "Mine lehele",
          points: ["Klõpsa lehe kaardil „Ava …”, et otse sinna minna."],
        },
        pageInfo: {
          title: "Saa abi igal lehel",
          points: [
            "Lehe pealkirja kõrval olev „i”-ikoon avab akna, mis selgitab, mida seal teha saab.",
            "„Näita” osutab nupule, mida tegevus kirjeldab.",
            "Selle otsingukast leiab samuti tegevusi kõigilt lehtedelt.",
          ],
        },
      },
    },
  },
};
